import i18next from 'i18next';

export const tg: i18next.ResourceLanguage = {
	Account: {
		Account: 'Утоқи шахсӣ',
		Email: 'Суроғаи почтаи эл.',
		Phone: 'Рақами телефон',
		'Please enter your phone number': 'Рақами телефони худро нишон диҳед',
		'Please enter your email': 'Суроғаи почтаи электронии худро нишон диҳед',
		'Contact details are necessary for us to be able to pass on the latest flight information.':
			'Иттилооти тамосӣ лозим аст, то ки шумо иттилооти охиронро дар бораи самтҳои парвоз гирифта тавонед',
		'Add login through your social network account':
			'Илова кардани даромадан тавассути аккаунт дар шабакаҳои иҷтимоӣ',
		'I want to receive news and special offers': 'Ман навидҳо ва пешниҳоди махсусро гирифтан мехоҳам',
		'Load personal data according to the standard of GDPR': 'Боркунии маълумотҳои шахсӣ мутобиқи стандарти GDPR',
		Terms: 'Қоидаҳо',
		'Delete my account': 'Нест кардани аккаунт',
		'Are you sure?': 'Боварӣ доред?',
		'Are you sure you want to delete your account?': 'Боварӣ доред, ки аккаунтро нест кардан мехоҳед?',
		'Yes, Delete account': 'Ҳа, аккаунт нест кард шавад',
		'Please enter a valid email': 'Суроғаи почтаи электрониро тафтиш кунед',
		'Please enter a valid phone': 'Рақами телефонро тафтиш кунед',
		'Confirmation code': 'Коди тасдиқкунӣ',
		'We sent verification code to new email': 'Коди тасдиқкуниро ба суроғаи почтаи электронии нав фиристодем',
		'We sent verification code to the phone': 'Коди тасдиқкуниро ба рақами телефони нав фиристодем',
		'Didn\'t get the code?': 'Кодро нагирифтед?',
		'Resend it': 'Боз як маротиба фиристодан',
		Orders: 'Бандкуниҳои ман',
		'Please confirm your email': 'Суроғаи почтаи электронии худро тасдиқ кунед',
		'Please confirm your phone number': 'Рақами телефони худро тасдиқ кунед',
		Confirm: 'Тасдиқ кардан',
		Save: 'Маҳфуз кардан',
		Send: 'Фиристодан',
		'Travel companions': 'Ҳамсафарон',
		Logout: 'Баромадан',
		'Personal details': 'Профил',
		Settings: 'Танзимот',
		'Incorrect card number or password': 'Рақами нодурусти корт ё ки рамз',
		'Loyalty program': 'Барномаи садоқат',
		FFP: 'Барномаи садоқат',
		'Loyalty card number': 'Рақами корти садоқат',
		Password: 'Рамз',
		'Client support': 'Ёрӣ',
		No: 'Не',
		'Log out': 'Баромадан',
		'Phone is already in use by another account': 'Ин телефон аллакай дар аккаунти дигар истифода бурда мшавад',
		'Email is already in use by another account': 'Ин почта аллакай дар аккаунти дигар истифода бурда мшавад',
		'Failed to fetch': 'Ҳангоми иҷрокунии дархост хатогӣ рух дод',
		'Oops...': 'Упс...',
		'OK, thank you': 'Фаҳмо, ташаккур',
		'An error occurred while executing the request. Please try again later or contact a customer support service.':
			'Ҳангоми иҷрокунии дархост хатогӣ рух дод Такроран кӯшиш кунед ё ки бо хадамоти дастгирии мизоҷон тамос гиред.',
		'Error on confirming': 'Коди тасдиқкунии нодуруст',
		'My cabinet': 'Меню',
		'Orders that were booked on a previous version of the site are available':
			'Фармоишҳои дар версияи қаблии сомона ба расмият дароварда шуда, дар ин ҷо дастрасанд',
		'this link': 'истинод',
		'Operations history': 'Таърихи амалиётҳо',
		Date: 'Сана',
		Operation: 'Амалиёт',
		Balance: 'Тавозун',
		'Status miles': 'Миляҳои мавқеъӣ',
		Assessed: 'Ҳисоб када шуд',
		'Add booking': 'Илова кардани бандкунӣ',
		'Ticket or booking number': 'Рақами чипта ё ки бандкунӣ',
		'Online check-in': 'Бақайдгирии онлайнӣ',
		'Search flights': 'Ҷустуҷӯи самтҳои парвоз',
		'I have a booking': 'Бандкунӣ дорам',
		'Check-in': 'Қайд ба самти парвоз',
		'How to find a booking id?': 'Идентификатори бандкуниро чӣ тавр бояд ёфт?',
		'Check-in conditions': 'Шартҳои бақайдгирӣ',
		Cancel: 'Бекор кардан',
		Continue: 'Давом додан',
		'Last name': 'Насаб',
		'Enter the passengers surname (in latin characters) and ticket number, order ID or booking ID. You can find these in the itinerary receipt sent to purchasers Email after booking.':
			'Рақами мусофирро (бо ҳуруфи лотинӣ) ва рақами чипта, рақами фармоиш ё ки рақами бандкуниро ворид кунед. Онҳоро дар расиди хатсайрии ба харидорон тавассути почтаи электронӣ баъд аз бандкунӣ фиристодашуда ёфта метавонед.',
		'Online check-in opens 30 hours and closes 50 minutes before departure':
			'Бақайдгирии онлайнӣ 30 соат қабл кушода мешавад ва 50 дақиқа қабл аз парвоз пӯшида мешавад.',
		'Baggage claim closes 40 minutes before flight departure. Please, check that your hand luggage weight is up to 10 kg and size does not exceed 55x40x23 cm':
			'Супоридани бағоҷ 40 дақиқа то парвози самти парвоз пӯшида мешавад. Лутфан, боварӣ ҳосил кунед, ки вазни бори дастии шумо то 10 кг-ро ташкил медиҳад, андозаи он аз 55x40x23 см бештар нест.',
		'Please, make sure te passenger is not included in special category':
			'Боварӣ ҳосил кунед, ки мусофир ба тоифаи махсус ворид нест.',
		'Purchase for miles': 'Харидан бар ивази миляҳо',
		'Please fill in the missing fields': 'Лутфан, майдонҳои намерасидаро пур кунед',
		'Confirm your contacts': 'Тамосҳои худро тасдиқ кунед',
		'Set your preferences': 'Афзалдониҳои худро нақл кунед',
		'Add your phone number': 'Рақами телефони худро илова кунед',
		'Keep building my profile': 'Давом додани пуркунии профил',
		'Enter your name': 'Номи худро пур кунед',
		'Welcome!': 'Хуш омадед!',
		'Usually traveling with a friend or family?': 'Бо оила ё ки дӯстон зуд-зул саёҳат мекунед?',
		'Add them to your companions list and make checking-in altogether easier.':
			'Барои тезонидани ҷараёни воридкунии маълумотҳо, ҳамсафарҳои худро ба ин рӯихат илова кунед',
		Passengers: 'Мусофирон',
		'Add companion': 'Илова кардани ҳамсафар',
		'Next flights': 'Парвози наздиктарин',
		'My office': 'Утоқи ман',
		Home: 'Асосӣ',
		'Login settings': 'Танзимоти даромадан',
		'Social networks accounts': 'Даромадан тавассути шабакаҳои иҷтимоӣ',
		'Mail settings': 'Фиристодани навидҳо',
		Profile: 'Профил',
		Edit: 'Тағйир додан',
		Miles: 'Миляҳо',
		'Searching flight': 'Ҷустуҷӯи самти парвоз:',
		'Flight found': 'Самти парвози ёфташуда:',
		'View booking': 'Дидан',
		'View and add to cabinet': 'Дидан ва илова кардан',
		Communications: 'Коммуникатсияҳо',
		Connect: 'Пайваст кардан',
		Connected: 'Пайваст гардида',
		'Not connected': 'Пайваст нагардида',
		'Email will be removed from your login methods': 'Почтаи {{email}} аз усулҳои даромадан нест карда мешавад',
		'Phone will be removed from your login methods': 'Телефони {{phone}} аз усулҳои даромадан нест карда мешавад',
		'FFP will be removed from your login methods': 'Корти садоқати {{ffp}} аз усулҳои даромадан нест карда мешавад',
		'Login method removal': 'Несткунии усули даромадан',
		Remove: 'Нест кардан',
		'method will be removed from your login methods': '{{method}} аз усули воридшавӣ нест карда мешавад',
		'Add a new login method': 'Илова кардани усули нави даромадан',
		Add: 'Илова кардан',
		'A confirmation code will be sent to your address': 'Коди тасдиқкунӣ ба почтаи шумо фиристода мешавад',
		'A confirmation code will be sent to your phone': 'Коди тасдиқкунӣ ба телефони шумо фиристода мешавад',
		'Change login method': 'Тағйир додани усули даромадан',
		'Error on sending secure code': 'Хатогӣ ҳангоми фиристодани коди тасдиқкунӣ',
		'Email for notification': 'Почта барои хабарномаҳо'
	},
	AddPassenger: {
		'Add passenger': 'Илова кардани мусофир',
		'Passenger last name': 'Насаби мусофир',
		'Ticket number or booking reference': 'Рақами чипта ё ки коди бандкунӣ',
		'Ticket number': 'Рақами чипта',
		Find: 'Ёфтан',
		'Required field': 'Сатри ҳатмӣ',
		'Passenger not found': 'Мусофир ёфт нашуд',
		Add: 'Илова кардан'
	},
	AdditionalBaggage: {
		'More bags?': 'Бағоҷ лозим аст?',
		'Buy now and save 20-30%': 'Ҳозир то 30% сарфа кунед',
		'Check-in bags': 'Бағоҷ',
		'Leave them at the check-in desk. Up to 3 bags per passenger. Price per flight.':
			'Leave them at the check-in desk. Up to 3 bags per passenger. Price per flight.',
		Add: 'Илова кардан',
		from: 'аз',
		Edit: 'Тағйир додан',
		total: 'ҳамагӣ',
		'Check-in baggage': 'Бағоҷ',
		'More baggage for you': 'Бағоҷро интихоб кунед',
		Overweight: 'Аз ҳад гузаштани бағоҷ',
		'Need to add another 10-30 kg to your total checked baggage?': 'Ба бағоҷи худ 10-30 кг иловагӣ илова кунед'
	},
	AdditionalServiceCard: {
		Add: 'Илова кардан',
		Remove: 'Нест кардан',
		Insurance: 'Суғуртакунӣ',
		Transfer: 'Аэроэкспресс',
		'Terms of service': 'Шартҳои',
		Select: 'Интихоб кардан',
		Selected: 'Интихоб шуд',
		'Enter document number': 'Рақами РМА-ро ворид кунед',
		Required: 'Майдонро пур кунед',
		'Only digits': '12 рақамро ворид кунед',
		Done: 'Омода',
		Clear: 'Тоза кардан'
	},
	AdditionalServiceWrapper: {
		'Full conditions': 'Шартҳои пурра',
		Cancel: 'Бекор кардан',
		Ok: 'Тасдиқ кардан',
		Clear: 'Тоза кардан',
		Confirm: 'Тасдиқ кардан',
		Total: 'Ҳамагӣ'
	},
	Aeroexpress: {
		ToAirport: 'Ба фурудгоҳ',
		'To airport': 'Ба фурудгоҳ',
		FromAirport: 'Аз фурудгоҳ',
		'No worries about traffic jams, arrival at the airport strictly on schedule':
			'Дар бораи тирбандиҳо хавотир нашавед, омадан ба фурудгоҳ - қатъиян аз рӯи ҷадвал',
		Add: 'Илова кардан',
		'Fast and convenient': 'Зуд ва қулай',
		Transfer: 'Аэроэкспресс',
		seat_0: '{{count}} ҷой',
		seat_1: '{{count}} ҷой',
		seat_2: '{{count}} ҷой',
		ticket_0: '{{count}} чипта',
		ticket_1: '{{count}} чипта',
		ticket_2: '{{count}} чипта',
		Cancel: 'Рад кардан',
		Total: 'Ҳамагӣ: ',
		From: 'аз',
		'View schedule': 'Дидани ҷадвал',
		Terms: 'Шартҳо',
		Change: 'Тағйир додан',
		Done: 'Омода',
		Clear: 'Тоза кардан',
		'Download tickets': 'Боргирии чиптаҳо',
		standart: 'Стандарт',
		business: 'Бизнес',
		Download: 'Боргирӣ кардан',
		full: 'Cтандарт',
		roundtrip: 'Roundtrip',
		Roundtrip: 'Ба ҳар ду тараф',
		To: 'то'
	},
	Aircraft: {
		Embraer: 'Эмбраер',
		'E190 E2': 'E190 E2',
		Economy: 'Эконом',
		Business: 'Бизнес',
		Premium: 'Премиум',
		'Seat pitch': 'Чуқурии курсӣ',
		'Up to': 'то',
		'"': '"',
		'Seat width': 'Васеъгии курсӣ',
		'Seat recline': 'Курсӣ ба қафо хам мешавад',
		'The Embraer E-Jet E2 family are medium-range jet airliners developed by Embraer, succeeding the original E-Jet. The program was launched at the Paris Air Show in 2013. The first variant, the E190-E2, took its first flight on 23 May 2016 and was certified on February 28, 2018 before entering service with Widerøe on 24 April. The three twinjet variants share the same four-abreast narrow-body fuselage with different lengths and three different new wings, Pratt & Whitney PW1000G turbofans in two sizes, fly-by-wire controls with new avionics, and an updated cabin.':
			'Оилаи Embraer E-Jet E2 - авиалайнерҳои реактивии масофаи миёна, ки аз ҷониби Embraer коркард гардидааст, ки E-Jet-и оригиналиро иваз кардааст. Барнома дар авиасалон дар Париж дар соли 2013 оғоз карда шудааст. Варианти якум, E190-E2, парвози аввалини худро санаи 23 майи соли 2016 содир кардааст ва санаи 28 феврали соли 2018 сертифитсиронида шуда, баъдан санаи 24 апрел ба саф бо Widerøe ворид гардид. Се варианти Twinjet худи як баданаи чорконтураи танг бо дарозии гуногун ва се қаноти нав, бодпаракҳои турбореактивии Pratt &amp; Whitney PW1000G бо ду андоза, ҷузъҳои идоракунӣ дар парвоз бо авионикаи нав ва кабинаи навсозишударо доранд.',
		Max: 'Макс',
		nmi: 'nmi',
		ft: 'фт.',
		cm: 'см',
		'National origin': 'Истеҳсолот',
		Brasil: 'Бразилия',
		Manufacturer: 'Истеҳсолкунанда',
		Status: 'Ҳолат',
		'In service': 'Хизматр расонида мешавад',
		Produced: 'Истеҳсол шудааст',
		'Flight deck crew': 'Даста',
		'2 pilots': '2 пилот',
		'Seating, dual class': 'Seating, dual class',
		'96 12j @38in': '96 12j @38in',
		'18.3 in (46 cm)': '18.3 in (46 cm)',
		Length: 'Дарозӣ',
		'36.24 m': '36,24 м.',
		Wingspan: 'Дарозии қанот',
		'33.72 m': '33,72 м.',
		Speed: 'Суръат',
		'Mach 0.82 (473 kn; 876 km/h) Max': 'Мах 0.82 (473; 876 км/соат) Макс.',
		'Range (full pax)': 'Дарозии парвоз',
		'3,250 nmi (6,020 km)': '3,250 nmi (6,020 км)',
		'Service ceiling': 'Баландии максималӣ',
		'41,000 ft (12,000 m)': '41,000 фт. (12,000 м)',
		Engines: 'Муҳаррикҳо',
		'2× Pratt & Whitney PW1919G/21G/22G/23G': '2× Pratt &amp; Whitney PW1919G/21G/22G/23G',
		Title_PassengerCapacity: 'Ғунҷоиш',
		Title_CruisingSpeed: 'Суръат',
		Title_MaxFlightRange: 'Масофа',
		Unit_PassengerCapacity: 'ҷой',
		Unit_CruisingSpeed: 'км/соат',
		Unit_MaxFlightRange: 'км'
	},
	Airport: {
		'Open web site': 'Кушодани сомона',
		Departures: 'Парвозҳо',
		Arrivals: 'Омаданҳо',
		Summary: 'Иттилоот',
		Services: 'Хизматрасониҳо',
		Map: 'Харита'
	},
	BaggagePage: {
		Baggage: 'Бағоҷ',
		'Transportation of impressions no limitations': 'Гузаронида бурдани таассурот бе маҳдудият',
		'Baggage rules': 'Қоидаҳои кашонидани бағоҷ',
		Adult: 'Калонсол',
		Child: 'Кӯдак',
		Infant: 'Навзод'
	},
	BaggageService: {
		'Set the same baggage for each flight': 'Миқдори якхелаи бағоҷ ба ҳамаи самтҳо',
		'Set the different baggage for each flight': 'Миқдори гуногуни бағоҷ ба ҳамаи самтҳо',
		'If the dimensions of your carry-on baggage exceed the permitted dimensions of 40x30x20 cm, you can increase its size up to 55x40x20 cm':
			'Агар андозаҳои бори дастии шумо аз андозаҳои иҷозатдодашудаи 40х30х20 см бештар бошанд, шумо андозаи онро то 55х40х20 см зиёд карда метавонед',
		'Sports equipment': 'Лавозимоти варзишӣ',
		'Add sports equipment': 'Илова кардани лавозимоти варзишӣ',
		'Your can bring your ski, snowboard, surf equipment, bicycle, etc. packed in a pouch':
			'Шумо бо худ дар ғилоф лижаҳо, сноуборд, дучархаро гирифта метавонед',
		included: 'ворид аст',
		Add: 'Илова кардан',
		Selected: 'Интихоб шуд',
		kg: 'кг',
		'pcs.': 'дона',
		Overweight: 'Зиёд шудани вазни бағоҷ',
		'Improve baggage weight you can bring to airplane':
			'Агар вазни бағоҷи шумо аз меъёри иҷозатдодашуда бештар бошад, шумо вазни онро зиёд карда метавонед',
		'{{value}} kg': '{{value}} кг',
		'Checked-in baggage': 'Бағоҷи бақайдгирифташуда',
		'up to {{value}} kg': 'то {{value}} кг',
		'Increasing the size of carry-on baggage': 'Зиёдкунии андозаҳои бори дастӣ',
		'You can bring your ski, snowboard, surf equipment, bicycle, golf bag, etc.':
			'Шумо бо худ лижаҳо, сноуборд, лавозимот барои серфинг, дучарха, халта барои голф ва ғайраро гирифта метавонед',
		Done: 'Омода',
		Clear: 'Тоза кардан',
		RUB: '₽',
		USD: '$',
		from: 'аз',
		'The service is applied to directions': 'Хизматрасонӣ дар ин самтҳо татбиқ мешавад',
		'The service is applied to all directions': 'Хизматрасонӣ дар ҳамаи самтҳо татбиқ мешавад',
		CarryOn: 'Бори дастӣ',
		Baggage: 'Бағоҷ',
		SportingEquipment: 'Таҷҳизоти махсус'
	},
	BaggageTotalPriceBlock: {
		Add: 'Илова кардан',
		edit: 'Тағйир додан',
		from: 'Аз',
		'More bags': 'Бағоҷ'
	},
	Cart: {
		Flights: 'Парвозҳо',
		Baggage: 'Бағоҷ',
		Seats: 'Ҷойҳо',
		Meal: 'Ғизо',
		Passengers: 'Мусофирон',
		Contacts: 'Тамосҳо',
		'All flights': 'Ҳамаи самтҳои парвоз',
		Total: 'Ҳамагӣ:',
		Close: 'Пӯшидан',
		ADT: 'Калонсол',
		CLD: 'Кӯдак',
		INF: 'Навзод',
		INS: 'Навзод бо ҷой',
		Extra: 'Иловагӣ',
		Aeroexpress: 'Аэроэкспресс',
		Insurances: 'Суғуртакунӣ',
		'Business lounge': 'Толори бизнес',
		'The service you have added cannot be activated. Try connecting later or contact the airline operator.':
			'Хизматрасонии иловакардашудаи шумо фаъол карда шуда наметавонад Барои дертар пайваст шудан кӯшиш кунед ва ба оператори ширкати ҳавопаймоӣ муроҷиат намоед.',
		'The service is awaiting confirmation. Do not close or refresh the window.':
			'Хизматрасонӣ тасдиқро интизор аст. Равзанаро напӯшед ва нав накунед.'
	},
	Checkin: {
		'Oops, something went wrong': 'Уҳ, чизе нодуруст шуд',
		'But don\'t worry, all of our systems have been duplicated several times. You can register on the backup version of the site.':
			'Вале хавотир нашавед, ҳамаи системаҳои мо якчанд маротиба такрор шудаанд. Шумо аз қайд дар версияи эҳтиётии сомона гузашта метавонед.',
		Go: 'Гузариш ба сомонаи эҳтиётӣ',
		'Try again': 'Як маротибаи дигар кӯшиш кардан',
		From: 'Аз',
		'Please, enter your contacts': 'Лутфан, маълумоти тамосии худро ворид намоед',
		'Ticket number or booking reference': 'Рақами чипта ё ки коди бандкунӣ',
		'Inflight insurance or baggage insurance is your travel confidence.':
			'Суғурта дар вақти парвоз ё ки суғуртакунии бағоҷ - боварии шумо дар саёҳат',
		'Checkin canceled, you will be redirected to the beginning':
			'Бақайдгирӣ бекор гардид, шумо ба аввал баргардонида мешавед',
		'Passenger last name': 'Насаби мусофир',
		'Oops...': 'Упс...',
		Continue: 'Давом додан',
		'OK, thank you': 'Фаҳмо, ташаккур',
		'An unexpected error has occurred during the start of the check-in process. Please try again later or contact a customer support service.':
			'Ҳангоми кӯшиши оғозкунии бақайдгирии онлайнӣ хатогӣ рух дод. Такроран кӯшиш кунед ё ки бо хадамоти дастгирии мизоҷон тамос гиред.',
		'Online check-in': 'Бақайдгирии онлайнӣ',
		Passengers: 'Мусофирон',
		Next: 'Баъдан',
		'Find booking': 'Ҷустуҷӯи фармоиш',
		Baggage: 'Бағоҷ',
		Seats: 'Интихоби ҷой',
		Meal: 'Ғизо',
		Payment: 'Пардохт',
		'Boarding pass': 'Талони саворшавӣ',
		'Choose passengers for check-in': 'Мусофиронро барои бақайдгирӣ интихоб кунед',
		'How to find a booking?': 'Фармоишро чӣ тавр бояд ёфт?',
		'Enter the passenger last name (in latin characters) and the booking code. \nYou can find it in the itinerary receipt sent to your email after booking.':
			'Дар шакл рақами чипта ё ки коди бандкунӣ ва насаби мусофирро нишон диҳед. Баъд аз он ба тугмаи «Ҷустуҷӯ» пахш кунед.',
		'Incorrect last name or booking code': 'Насаб ё ки коди бандкунии нодуруст',
		'Check-in Successful': 'Бақайдгирӣ гузашта шуд',
		'Sorry,': 'Мутаассифона,',
		'online check-in is closed for this flight': 'бақайдгири онлайнӣ ба ин самти парвоз пӯшида аст',
		OK: 'OK',
		'You can now download and print your boarding passes. You will need them at the airport.':
			'Чопкунии талонҳои саворшавиро фаромуш накунед. Онҳо ба шумо ҳангоми гузаштани муоинаи пеш аз парвозӣ, дар назорати шиносномавӣ, баромадан ба саворшавӣ ва дар борти ҳавопаймо лозиманд.',
		'An error occurred during the check-in process. Please try again later or contact a customer support service.':
			'Ҳангоми кӯшиши содир кардани бақайдгирии онлайнӣ хатогӣ рух дод. Такроран кӯшиш кунед ё ки бо хадамоти дастгирии мизоҷон тамос гиред.',
		'Anything else for your trip?': 'Боз чизе дигар?',
		Extras: 'Хизматрасониҳои иловагӣ',
		'Online check-in will close at': 'Анҷоми бақайдгирии онлайнӣ дар',
		'To complete online check-in you must choose seats for all passengers on all flight directions':
			'Барои бақайдгирии онлайнӣ ба самти парвоз, дар салони ҳавопаймо барои ҳамаи мусофирон ва ба ҳамаи самтҳо ҷойҳоро интихоб кардан лозим аст',
		'Unfortunately, check-in cancellation is prohibited for this flight. Please contact a customer support service for further details.':
			'Мутаассифона, бекоркунии бақайдгирии онлайнӣ дар ин самти парвоз манъ. аст. Барои гирифтани иттилооти муфассал бо хадамоти дастгирии мизоыон муроҷиат кунед.',
		'Please, enter your visa details': 'Лутфан, маълумотҳо оиди раводидро пур кунед',
		Save: 'Маҳфуз кардан',
		Download: 'Боргирӣ кардан',
		'Go to home': 'Ба асосӣ гузаштан',
		'Business lounge': 'Толори бизнес',
		from: 'аз',
		Change: 'Тағйир додан',
		'No visa required': 'Паси сар кардан',
		'Start online check-in': 'Бақайдгирии онлайнӣ',
		'Last name': 'Насаб',
		'Ticket / booking number': 'Рақами чипта / бандкунӣ',
		'Booking not found':
			'Бандкунӣ ёфт нашуд. Лутфан, иттилооти воридкардашударо пур кунед ё ки аз рақами чиптаи электронӣ барои идентификатсия истифода баред',
		Required: 'Сатри ҳатмӣ',
		'Incorrect value': 'Қимати носаҳеҳ',
		'How to find a booking id?': 'Рақами бандкуниро чӣ тавр бояд ёфт?',
		HelpBookingFind:
			'Рақами мусофирро (бо ҳуруфи лотинӣ) ва рақами чипта, рақами фармоиш ё ки рақами бандкуниро ворид кунед. Онҳоро дар расиди хатсайрии ба харидорон тавассути почтаи электронӣ баъд аз бандкунӣ фиристодашуда ёфта метавонед.',
		Conditions: 'Шартҳо',
		Add: 'Илова кардан',
		Cancel: 'Бекор кардан',
		'airport local time': 'аз рӯи вақти маҳаллии фурудгоҳ',
		Attention: 'Диққат',
		'Check-in conditions': 'Шартҳои бақайдгирӣ',
		'Seats have already been assigned by the airline and check-in is only available at the counter at the airport':
			'Ҷойҳо аллакай аз ҷониби ширкати ҳавопаймоӣ банд карда шудаанд ва бақайдгирӣ танҳо дар поя дар фурудгоҳ имконпазир аст',
		Close: 'Пӯшидан',
		'Invalid seat number':
			'Бақайдгирии онлайнӣ бо ҷойи {{seatNumber}} имконнопазир аст, шумо бояд қайдро дар поя дар фурудгоҳ гузаред.',
		'You can now download and print your boarding passes. You will need them at the airport.\n Please notice, for flight {{flight}} you must receive your boarding pass at the airport':
			'Чопкунии талонҳои саворшавиро фаромуш накунед. Онҳо ба шумо ҳангоми гузаштани муоинаи пеш аз парвозӣ, дар назорати шиносномавӣ, баромадан ба саворшавӣ ва дар борти ҳавопаймо лозиманд. Диққати шуморо ҷалб мекунем, ки барои самти парвози {{flight}} талони саворшавиро танҳо дар фурудгоҳ гирифтан мумкин аст.',
		'You can now download and print your boarding passes. You will need them at the airport.\n Please notice, for flight {{flight}} you must receive your boarding pass at the airport_1':
			'Чопкунии талонҳои саворшавиро фаромуш накунед. Онҳо ба шумо ҳангоми гузаштани муоинаи пеш аз парвозӣ, дар назорати шиносномавӣ, баромадан ба саворшавӣ ва дар борти ҳавопаймо лозиманд. Диққати шуморо ҷалб мекунем, ки барои самтҳои парвози {{flight}} талонҳои саворшавиро танҳо дар фурудгоҳ гирифтан мумкин аст.',
		'Service is temporarily unavailable. There are no seats available. Please try again later, or check in at the airport.':
			'Хизматрасонӣ муваққатан дастнорас аст. Ҷойҳои дастрас нестанд. Кӯшишро дертар такрор кунед, ё ки қайдро дар фурудгоҳ гузаред.',
		'Checkin available only in airport': 'Бақайдгирии онлайнӣ дастнорас аст. Бақайдгирӣ танҳо дар фурудгоҳ',
		'You cannot add a passenger because the currency of order is different from the currency of orders of previously added passengers.\nYou can check-in the passenger separately.':
			'Мусофирро илова кардан имконнопазир аст, зеро асъори фармоиши ӯ аз асъори фармоишҳои мусофирҳои қаблан иловакардашуда фарқ мекунад. Шумо ӯро ба самти парвоз алоҳида аз қайд гузаронида метавонед.',
		BaggageExcess: 'Зиёд шудани вазн',
		CarryOn: 'Бори дастӣ',
		CheckedBaggage: 'Бағоҷ',
		SportingEquipment: 'Лавозимоти варзишӣ',
		HandLuggageExcess: 'Бори дастӣ'
	},
	CheckinAddDocuments: {
		Submit: 'Маҳфуз кардан',
		'Add documents': 'Илова кардани ҳуҷҷатҳо'
	},
	CheckinConditions: {
		'Check-in conditions': 'Шартҳои бақайдгирӣ',
		Rules_0: 'Бақайдгирии онлайнӣ 24 соат қабл кушода мешавад ва 1 соат қабл аз парвоз пӯшида мешавад',
		Rules_1:
			'Лутфа, боварӣ ҳосил кунед, ки вазн ва андозаҳои бори дастии шумо ба меъёрҳои кашонидан мутобиқат доранд.',
		Rules_2: 'Лутфан, боварӣ ҳосил кунед, ки мусофири шумо ба тоифаи махсус тааллуқ надорад.'
	},
	CheckinRules: {
		Continue: 'Давом додан',
		'Terms & Conditions': 'Шартҳо ва оқидаҳои бақайдгирии онлайнӣ',
		'I have read and agreed to the online check-in terms and conditions':
			'Ман бо шартҳо ва қоидаҳои бақайдгирии онлайнӣ шинос шудам ва розиям',
		'Please read and accept the online check-in terms and conditions':
			'Лутфан, бо шартҳо ва қоидаҳои бақайдгирии онлайнӣ шинос шуда, ба онҳо розӣ шавед'
	},
	Checkout: {
		'Review your trip': 'Фармоиши шумо',
		'LOUNGE ACCESS': 'Толори бизнес',
		'PRE RESERVED SEAT ASSIGNMENT': 'Интихоби ҷой',
		Details: 'Тафсилот',
		'Miles will be credited to your account after the flight.':
			'Миляҳо ба суратҳисоби шумо баъд аз содир гардидани парвоз ворид мешаванд.',
		'Start earning miles now to flight cheaper': 'Барои арзонтар паридан гирифтани миляҳоро оғоз кунед',
		Register: 'Аз қайд гузаштан',
		'View status': 'Дидани ҳолат',
		'{{number}} {{miles}} will be awarded': '{{number}} {{miles}} ҳисоб карда мешавад',
		miles: 'миля',
		miles_0: 'миля',
		miles_1: 'миляҳо',
		miles_2: 'миля',
		'Light Jet Club': 'Websky Club',
		'Get our latest offers': 'Махсус барои шумо',
		Cancel: 'Рад кардан',
		'Sign up for NORDWIND newsletter and enjoy invites to major sales and exclusive offers and always be in the know.':
			'Ба навидҳои ширкати ҳавопаймоии Nordwind обуна шав ва ба ҳамаи фурӯшҳои мубрам, пешниҳодҳои аҷоиб даъватномаҳоро қабул намо ва ҳамеша аз нақшаҳои мо бохабар бош.',
		'I accept the': 'Ман розиям бо ',
		'terms of agreement': 'шартҳои шартнома',
		'terms of insurances': 'шартҳои суғуртакунӣ',
		'Sorry, the price has changed to': 'Мутаассифона, нарх тағйир ёфт ба',
		'Wow, the price has changed to': 'Оҳо, нарх афтид то',
		'We recommend buying your tickets now to avoid another price increase.':
			'Нархҳо дар вақти дилхоҳ тағйир ёфта метавонанд, харидҳоро ба қафо нагузоред!',
		'Sorry, flight is either not available or sold out':
			'Мутаассифона, дар ин самти парвоз ҷойҳо ба анҷом расиданд',
		'Please, choose another flight.': 'Лутфан, самти парвози дигарро интихоб',
		'Choose another flight': 'Интихоб кардани самти парвози дигар',
		'old price': 'нархи қаблӣ',
		'Change flight': 'Иваз кардани хатсайр',
		Continue: 'Давом додан',
		Required: 'Пур кардан лозим аст',
		'Please, read the rules of service and accept it':
			'Барои давом додан, лутфан, бо қоидаҳои пешкашкунии хизматрсониҳо шинос шуда, розӣ шавед',
		Seats: 'Ҷойҳо',
		Baggage: 'Бағоҷ',
		Meal: 'Ғизо',
		'Select seats': 'Интихоб кардани ҷойҳо',
		'Select meal': 'Интихоб кардани ғизо',
		'Checked-in baggage': 'Бағоҷи иловагӣ',
		Adult: 'Калонсол',
		Child: 'Кӯдак',
		Infant: 'Навзод',
		Status: 'Ҳолати радкунӣ',
		'Payment details': 'Детализатсияи арзиш',
		Service: 'Хизматрасонӣ',
		'processing of my personal data': 'шартҳои коркарди маълумотҳои шахсӣ',
		'general transportation rules': 'қоидаҳои умумии кашониданҳо',
		'and I accept it. I am aware that the fee for unused additional services is not refundable.':
			'ва онҳоро қабул мекунам. Ман огоҳ карда шудам, ки пардохт барои хизматрасониҳои истифоданашудаи иловагӣ баргардонида намешавад.',
		and: 'ва',
		Price: 'Нарх',
		Total: 'Ҳамагӣ',
		Booked: 'Банд карда шуд',
		Cancelled: 'Бекор гардид',
		Confirmed: 'Ба расмият дароварда шуд',
		New: 'Нав',
		'Thank you for your booking!': 'Чиптаҳо бомуваффақият ба расмият дароварда шуданд!',
		Back: 'Ба қафо',
		'Priority boarding': 'Саворкунии бартариятдошта',
		Insurance: 'Суғуртакунӣ',
		Transfer: 'Трансфер',
		Aeroexpress: 'Аэроэкспресс',
		Flight: 'Парвоз',
		Flights: 'Парвозҳо',
		'Selected options': 'Парвозҳои интихобшуда',
		Clarification: 'Диққат диҳед',
		'Skip the line at the gate and board the aircraft early.': 'Саворшавӣ дар навбати аввал ва бе навбатҳо.',
		'Guaranteed overhead baggage space.': 'Ҷойҳои кафолатдодашуда барои бағоҷ.',
		'More time to get comfortable on board.': 'Саворкунӣ то мусофирони боқимонда.',
		'Coverage for medical expenses, also suitable for visa. Business lounge in case of delay. Get 30 miles':
			'Ҳолатҳои тиббӣ, инчунин ҳолат бо раводидҳо рӯйпӯш мекунад. 30 миляи иловагӣ гиред',
		'No worries about traffic jams, arrival at the airport strictly on schedule.':
			'Оиди тирбандиҳо ташвиш накашед. Трансфер то маркази шаҳр дарҳол баъд аз саворкунӣ.',
		'Be among the first to board': 'Дар шумораи мусофирони якум',
		'Basic Packet': 'Бастаи асосӣ',
		'Fast and convenient': 'Зуд ва қулай',
		'Are you sure you are ready to remove insurance?': 'Боварӣ доред, ки суғуртаро рад карданиед?',
		'Inflight insurance or baggage insurance is your travel confidence.':
			'Суғурта дар вақти парвоз ё ки суғуртакунии бағоҷ - боварии шумо дар саёҳат',
		'Flying with risk': 'Ҳамаи хатарҳоро ба худ мегирам',
		Insure: 'Гузоштани суғурта',
		Add: 'Илова кардан',
		'Download policy': 'Боргирӣ кардани полис',
		'Show details': 'Дидати тафсилот',
		'Hide details': 'Пинҳон кардани тафсилот',
		'Go to online check-in': 'Бақайдгирии онлайнӣ',
		'Change / Refund': 'Мубодила / Баргардонидан',
		'Tickets have been sent to {{email}}': 'Чиптаҳо ба {{email}} фиристода шуданд',
		'Resend it': 'Боз фиристодан',
		'Enjoy the extended range of dishes and top-notch services on board, earn extra miles':
			'Аз намудҳои васеъи таъомҳо ва хизматрасонии дараҷаи якум дар борт ҳаловат баред, миляҳои иловагӣ ба даст оред',
		Passengers: 'Мусофирон',
		'Oops...': 'Упс...',
		'OK, thank you': 'Фаҳмо, ташаккур',
		'An unexpected error has occurred during the booking process. Please try again later or contact a customer support service.':
			'Ҳангоми бандкунии ҷойҳо хатогӣ рух дод. Такроран кӯшиш кунед ё ки бо хадамоти дастгирии мизоҷон тамос гиред.',
		'An unexpected error has occurred during the tickets downloading process. Please try again later or contact a customer support service.':
			'Ҳангоми боркунии чиптаҳо хатогӣ рух дод. Такроран кӯшиш кунед ё ки бо хадамоти дастгирии мизоҷон тамос гиред.',
		Send: 'Фиристодан',
		Email: 'Суроғаи почтаи эл.',
		'Resend booking': 'Фиристодани чиптаҳо',
		'Failed to send tickets to the specified mail, try again later':
			'Чиптаҳоро ба почтаи нишондодашуда фиристода нашуд, такроран кӯшиш кунед',
		'Please enter a valid email': 'Суроғаи иловакардашудаи почтаро тафтиш кунед',
		'Select seat': 'Интихоб кардани ҷой',
		'If you will not select a seat now, we will automatically select it for you upon check-in.':
			'Ҳозир интихоб кардани ҷойро тавсия медиҳем, ҷойҳои беҳтарин ба аввалинҳо насиб мекунанд!',
		'Next step': 'Гузариш ба барасмиятдарории хизматрасониҳо',
		'Now you will be redirected to the previous version of the site. There you can choose ancillary services.':
			'Ҳоло мо шуморо ба версияи қаблии сомона равона мекунем. Муваққатан, айнан дар он ҷо, шумо хизматрасониҳои иловагии ба шумо лозимиро ба расмият даровардан ва парвози худро фаромушнашаванда карда метавонед.',
		'Add now': 'Интихоб кардани хизматрасониҳо',
		'Order has been cancelled': 'Фармоиш бекор карда шуда буд',
		'Your special comfort on board': 'Ҳаловат дар борт',
		'Improve your flight right now by adding the pleasant and necessary comfort with special food, extra baggage and the best places with amazing views.':
			'Парвози худро ғайриоддӣ кунед Ба фармоиши худ ғизои олӣ, бағоҷи иловагӣ ва бори дастиро илова кунед ё ки аз намуди тааасуротбахш аз иллюминатор ҳаловат гиред.',
		Resend: 'Боз фиристодан',
		'Thank you for your choice. All need documents has been sent to your e-mail address.':
			'Барои интихоби шумо ташаккур. Ҳамаи ҳуҷҷатҳои зарурӣ ба почтаи электронии шумо равона карда шуда буданд.',
		'Paid by credit card': 'Бо корт пардохт шудааст',
		'Waiting for payment expires at': 'Анҷоми интизории пардохт дар',
		Ref: 'Рақами фармоиш',
		'Security code': 'Коди дастрасӣ',
		Download: 'Боргирӣ кардан',
		'Price details': 'Ҳамагӣ',
		'Baggage rules': 'Қоидаҳои кашонидани бағоҷ',
		'Feel the taste in flight!': 'Таъмро дар парвоз эҳсос намоед!',
		'Transportation of impressions no limitations': 'Гузаронида бурдани таассурот бе маҳдудият',
		'The top ones get the top seats!': 'Ҷойҳои беҳтарин ба аввалинҳо насиб мекунад!',
		'Fly in comfort': 'Дар муҳити ҳаловат парвоз кунед',
		from: 'аз',
		Change: 'Тағйир додан',
		Refund: 'Баргардонидан',
		Exchange: 'Мубодила',
		'Seat selection is available in the online registration service':
			'Интихоби ҷой да хадамоти бақайдгирии онлайнӣ дастрас аст',
		'You can select seats using the online registration service after issuing tickets':
			'Шумо ба интихоби ҷой бо истифода аз хизматрасонии бақайдгирии онлайнӣ баъд аз ба расмият даровардани чипта гузашта метавонед',
		'Business lounge': 'Толори бизнес',
		'The flight is available, hurry up with booking!': 'Ҷойҳо ҳоло дастрасанд, барои бандкунӣ шитобед!',
		'Attention, times have changed for flight {{route}}': 'Диққат! Ҳолати самти парвози {{route}} тағйир ёфт',
		'More details': 'Муфассалтар',
		'Capsule hotel': 'Меҳмонхонаи капсулагӣ',
		'per person': 'ба як нафар',
		'Full conditions': 'Шартҳои пурра',
		'Total for all passengers': 'Ҳамагӣ ба ҳамаи мусофирон',
		Aeroexpress_Cancel: 'Бекор кардан',
		Ok: 'Ок',
		Class_full: 'Стандарт',
		Class_business: 'Бизнес',
		Class_child: 'Бачагона',
		Class_family: 'Оилавӣ',
		Class_couple: 'Ҷуфтӣ',
		Class_standart: 'Стандарт',
		Class_roundtrip: 'Стандарт',
		Class_business_roundtrip: 'Бизнес',
		ToAirport: 'Ба як тараф',
		FromAirport: 'Ба як тараф',
		Roundtrip: 'Ба ҳар ду тараф',
		'And back': 'Ва бозгашт',
		'Aeroexpress tickets are valid for 30 days.': 'Чиптаҳо ба аэроэкспресс 30 рӯз эътибор доранд.',
		'passenger conduct rules': 'қоидаҳои рафтори мусофирон',
		'terms of tariff': 'шартҳои тарофа',
		'Search my booking': 'Ҷустуҷӯи фармоиш',
		Done: 'Омода',
		'Passenger not found. Please, check passenger last name and ticket number':
			'Мусофир ёфт нашуд, лутфан, маълумотҳои ворид карда шударо тафтиш кунед',
		'Add passenger': 'Илова кардани мусофир',
		'Add your travel companion to the order? Add ticket': 'Илова кардани мусофири ин фармоиш',
		'price for all persons': 'нарх барои ҳамаи шахсон',
		Select: 'Интихоб кардан',
		Reject: 'Рад кардан',
		'SMS notifications': 'СМС огоҳиномаҳо',
		Clear: 'Тоза кардан',
		'Open the full text of the conditions of carriage': 'Кушодани матни пурраи шартҳои кашонидан',
		Animal: 'Ҳайвоноти хонагӣ',
		'All payments will be charged in Russian rubles. The amounts indicated in other currencies are presented as a guideline.':
			'Ҳамаи пардохтҳо дар рублҳои Россия соқит карда мешаванд. Маблағи дар асъори дигар нишондодашуда ҳамчун иттилооти маълумотӣ пешкаш гардидаанд.',
		'Only 1 animal is allowed per adult passenger.': 'Ба 1 мусофири болиғ танҳо 1 ҳайвон иҷозат дода мешавад.',
		'Placement of passengers with an animal in the front rows is prohibited.':
			'Ҷойгиркунии мусофирон бо ҳайвонот дар қаторҳои якум манъ карда шудааст.',
		'Specify all passengers for whom you need to open an order for correct display.':
			'Ҳамаи мусофиронро, ки барои онҳо кушодани фармоиш зарур аст, барои инъикоси саҳеҳ нишон диҳед.',
		'View old booking': 'Кушодани фармоиши пайвастгардида',
		'Order created from': 'Фармоиш офарида шудааст аз',
		'You must select seats to proceed to the next step': 'Барои ба қадами навбатӣ гузаштан, ҷойро интихоб кунед',
		'All flight': 'Ҳамаи самтҳои парвоз',
		'Promo code': 'Промокод',
		Passenger: 'Мусофир',
		'Original price': 'Нархи аввала',
		'Final price': 'Нарх бо таҳфиф',
		'Total price': 'Нархи ниҳоӣ',
		'Correct promo codes': 'Ислоҳ кардани промокодҳо',
		'Check if the promo code is entered correctly or contact the call center of the airline':
			'Таҳфифҳои дастрас нестанд. Дурустии воридкунии промокодро тафтиш кунед ё ки бо маркази тамоси ширкати ҳавопаймоӣ тамос гиред.',
		'Add services': 'хизматрасониҳои иловагӣ',
		Error: 'Хато',
		'An error occurred while checking the promo code, change the promo code or continue without it':
			'Дар вақти тафтиши промокод хато рух дод, промокодро тағйир диҳед ё ки бе он давом диҳед.',
		'Promo codes not available': 'Промокодҳо дастрас нестанд',
		'We recommend using extra baggage': 'Аз бағоҷи иловагии "{{name}}" истифода бурданро тавсия медиҳем',
		'Extra delivery baggage':
			'Аз хизматрасонии нави "{{name}}" истифода бурданро тавсия медиҳем, бо осонӣ саёҳат кунед!',
		'Extra delivery baggage free for dates': 'Хизматрасонӣ барои парвозҳо аз 18.04.24 то 20.04.24 ройгон аст',
		Refuse: 'Рад кардан',
		Agree: 'Илова кардани хизматрасонӣ',
		Remove: 'Нест кардан',
		'Prices are for all passengers, including taxes and fees. By local time.':
			'Нархҳо барои ҳамаи мусофирон, аз он ҷумла, андозҳо ва боҷҳо нишон дода шудаанд. Вақти маҳаллӣ',
		'Error from supplier. Passenger\'s name and/or surname is too long':
			'Ном ва/ё ки насаби мусофир аз миқдори иҷозатдодашудаи аломатҳо зиёд аст',
		Confirm: 'Тасдиқ кардан',
		'Extra comfort': 'Ҳаловати иловагӣ',
		'VIP lounges, business lounges, priority pre-flight procedures':
			'VIP-толорҳо, бизнес-толорҳо, гузаштани тезонидашуда аз протседураҳо пеш аз парвозӣ',
		'To book': 'Банд кардан',
		'Your order was archived. Please contact with client support to get a receipt':
			'Фармоиш ба бойгонӣ гузаронида шуд. Барои гирифтани расиди хатсайрӣ ба Маркази дастгирӣ муроҷиат кунед.',
		PetPopupRule_0: 'Мо барои кашонидан дар салони ҳавопаймо қабул мекунем: сагҳо, гурбаҳо, инчунин паррандаҳо.',
		PetPopupRule_1: 'Вазни контейнер/қафас бо ҳайвонот набояд аз 8 кг бештар бошад.',
		PetPopupRule_2:
			'Андозаҳои контейнери сахт аз рӯи дарозӣ, васеъгӣ ва баландӣ набояд аз 60х35х20 см баланд бошанд.',
		PetPopupRule_3:
			'Андозаҳои контейнери мулоим (халтаи намуди пӯшида барои кашонидан) дар ҷамъи ченкуниҳо набояд аз 115 см бештар бошад.',
		PetPopupRule_4: 'Ба 1 мусофири болиғ танҳо 1 ҳайвон иҷозат дода мешавад.',
		PetPopupRule_5: 'Ҷойгиркунии мусофирон бо ҳайвонот дар қаторҳои якум манъ карда шудааст.',
		'Miles are not credited for this flight.': 'Миляҳо барои ин парвоз ҳисоб карда намешаванд.',
		'Baggage delivery': 'Дастраскунии бағоҷ',
		'per place': 'барои як ҷойи бағоҷ',
		'All passengers': 'Ҳамаи мусофирон',
		'View ticket': 'Дидани дархост',
		'We have received your request for a {{fields}} change for {{passengers}}':
			'Мо дархости шуморо барои тағйирдиҳии {{fields}} барои {{passengers}} қабул кардем',
		'Waiting for payment until {{date}}': 'Пардохтро то {{date}} интизор аст',
		'Expect confirmation shortly. Request date: {{date}}':
			'Тасдиқкуниро вақти наздиктарин интизор бошед. Санаи дархост: {{date}}',
		'Awaiting confirmation. Request date: {{date}}': 'Тасдиқро интизор аст. Санаи дархост: {{date}}',
		'Changes have been made to passenger data for {{passengers}}':
			'Тағйирот ба маълумотҳои мусофир {{passengers}} амалӣ карда шуданд. Чиптаҳои нав ба почта фиристода шуданд',
		'Request for a {{fields}} change for {{passengers}} has been declined':
			'Дархости барои тағйирдиҳии {{fields}} барои {{passengers}} рад карда шуд',
		'Proceeding to payment...': 'Лутфан, интизор шавед',
		'An order for this flight and the set of passengers already exists':
			'Фармоиш ба ин самти парвоз бо чунин маҷмуаи мусофирон аллакай вуҷуд дорад',
		'У разных элементов Traveller не может быть одинакового значение параметра LinkedTo, большего чем 0':
			'Худи як болиғ ҳамчун ҳамроҳикунанда барои ду ё ки бештар навзодон, ки ҷойи худро надоранд, буда наметавонад. Лутфан, калонсолони дигарро барои зар як кӯдакн нишон диҳед.',
		'You are not logged in': 'Авторизатсия нашудаед',
		'Add protection': 'Илова кардани муҳофиза',
		'Remove protection': 'Нест кардани муҳофиза',
		'For all passengers': 'Барои ҳамаи мусофирон',
		'Want to add extra protection while traveling?': 'Дар вақти сафар муҳофизаи иловагиро илова кардан мехоҳед?',
		InsuranceGroupTitle_default: 'Суғуртакунӣ',
		InsuranceGroupDescr_default: 'Ҷуброни хароҷот дар ҳолати таъхир ё ки бекор гардидани парвоз',
		InsuranceGroupTitle_common: 'Суғурта оид ба тағйирёбии парвоз',
		InsuranceGroupDescr_common:
			'Дар ҳолати бекор гардидан ё ки тағйир ёфтани санаҳои сафар <strong> то 40 000 RUB</strong> гиред.',
		InsuranceGroupTitle_flight: 'Суғуртакунии маҷмуавӣ дар вақти парвоз',
		InsuranceGroupDescr_flight:
			'Ҷуброни хароҷотҳо то 500 000 RUB дар ҳолати таъхир ё ки бекор гардидани парвоз, ҳифзи бағоҷ ва саломатӣ дар вақти парвоз.',
		InsuranceGroupTitle_med: 'Суғуртакунии тиббӣ',
		InsuranceGroupDescr_med:
			'Барои баромад ба хориҷа ҳатмист. Табобати амбулаторӣ ё ки статсионариро, инчунин COVID-19, дандонпизишкӣ, ҳамлу нақли тиббӣ, эвакуатсияи кӯдакон, барқароркунии ҳуҷҷатҳоро рӯйпӯш мекунад.',
		'Your booking ID': 'Коди бандкунии шумо',
		'Check the correctness of the entered data': 'Дурустии маълумотҳои ворид карда шударо тафтиш кунед',
		'You will not be able to change passenger details after purchasing a ticket.':
			'Маълумотҳои мусофирро баъд аз хариди чипта тағйир дода наметавонед.',
		Check: 'Тафтиш кардан'
	},
	CheckoutAdditionalService: {
		Add: 'Илова кардан',
		from: 'аз',
		Exclusive: 'Беҳамто'
	},
	CheckoutOrderSummary: {
		'Order must be paid': 'Фармоишро пардохт кардан лозим аст',
		before: 'то',
		'today before': 'имрӯз то',
		'View details': 'Тафсилоти парвоз',
		'Order number': 'Рақами фармоиш'
	},
	Communications: {
		Communications: 'Коммуникатсияҳо',
		Notifications: 'Огоҳиҳо',
		'My appeals': 'Муроҷиатҳои ман',
		Chat: 'Чат',
		Promotions: 'Огоҳиҳо',
		'Order notifications': 'Огоҳиномаҳо оид ба фармоишҳо',
		'My promo codes': 'Промокодҳои ман',
		Back: 'Ба қафо',
		'Mark all as read': 'Ҳамаашро ҳамчун хондашуда қайд кадан',
		Updated: 'Нав карда шуд',
		Created: 'Офарида шуд',
		Status: 'Ҳолат',
		Order: 'Фармоиш',
		'Book with promo code': 'Бо промо-код банд кунед',
		Personal: 'Фардӣ',
		Reusable: 'Бисёр истифода мешуда',
		New: 'Нав',
		WaitingAnswer: 'Ҷавобро интизор аст',
		InProgress: 'Дар кор',
		Solved: 'Иҷро шуд',
		Rejected: 'Рад карда шуд',
		Used: 'Истифода шуд',
		Expired: 'Муҳлаташ гузашт',
		'Can be used until': 'Истифода бурдан мумкин аст то',
		ID: 'ID',
		Oops: 'Упс...',
		'Something went wrong': 'Чизе нодуруст шуд',
		'Mark as read': 'Ҳамчун хондашуда қайд кардан',
		'There is nothing yet': 'Ҳоло ҳеҷ чиз нест',
		Empty_my_appeals: 'Шумо ҳоло муроҷиатҳо надоред',
		Empty_promotions: 'Шумо ҳоло хабарномаҳои маркетингӣ надоред',
		Empty_order_notifications: 'Шумо ҳоло фармоишҳо надоред',
		Empty_my_promo_codes: 'Шумо ҳоло промокодҳо надоред'
	},
	CompareFares: {
		Label: 'Тугма',
		'Internal error': 'Хатогии дохилӣ',
		'Compare fare families': 'Муқоисакунии оилаи тарофаҳо',
		Economy: 'Эконом',
		Light: 'Лайт',
		Classic: 'Классик',
		Flex: 'Чандир',
		Business: 'Бизнес',
		Premium: 'Премиум',
		Baggage: 'Бағоҷ',
		'Checked baggage': 'Бағоҷҳои аз қайд гузаронида шаванда',
		Services: 'Хизматрасониҳо',
		'Ticket changes': 'Тағйирот дар чипта',
		Cancellation: 'Бекор кардан',
		'In-Cabin service': 'Хизматрасонӣ дар борт',
		'Comfort kit': 'Comfort kit',
		'Airport sevices': 'Хизматрасониҳо дар фурудгоҳ',
		'Priority boarding': 'Саворкунии бартариятдошта',
		'Priority baggage delivery': 'Дастраскунии бартариятдоштаи бағоҷ',
		'Lounge service': 'Ҳуҷраи истироҳат',
		'View full fare conditions': 'Муқоисаи пурраи тарофаҳо',
		Note: 'Эзоҳ',
		'Go back': 'Баргаштан',
		'The fare difference is calculated taking into account the prices available through our global reservations system, not the airBaltic website':
			'Фарқият дар тарофаҳо бо назардоҳти нархҳои тавассути системаи глобалии бандкунии мо ҳисоб карда мешавад, на дар сомонаи airBaltic',
		'Please see detailed baggage rules that apply to airBaltic operated flights here':
			'Лутфан, бо қоидаҳои муфассали кашонидани бағоҷ, ки дар самтҳои парвози аз ҷониби airBaltic иҷрошаванда дар ин ҷо шинос шавед..',
		'Passengers in possession of roundtrip tickets who have flown or are planning to fly one way only and wish to receive a refund for the unused part of the ticket, please make sure that the ticket type supports cancellation with refund. In such cases the value of the used portion of the ticket will be recalculated to reflect the price of a one-way ticket, and the remaining difference will be refunded after subtracting any cancellation fees, if applicable to the particular ticket type.':
			'Мусофироне, ки ба ҳар ду тараф чипта доранд, ки танҳо ба як тараф парвоз карда омаданд ё ки нақшаи парвоз кардан доранд ва барои қисми истифоданашудаи чипта ҷуброн гирифтан мехоҳанд, боварӣ ҳосил намоед, ки намуди чипта бекоркунӣ бо баргардониданро дастгирӣ мекунад. Дар чунин ҳолатҳо арзиши қисми истифоданашудаи чипта аз нав ҳисоб карда мешавад, то ки арзиши чипта ба як тараф инъикос карда шуда, бақияи боқимонда баъд аз соқиткунии боҷҳои дилхоҳ баргардонида мешавад, агар ин ба намуди мушаххаси чипти татбиқ карда шаванда бошад.',
		'Name and/or surname change or correction is only possible if the ticket issued is an airBaltic document and the booking consists of flights operated by airBaltic.':
			'Тағйирдиҳӣ ё ки ислоҳкунии ном ва / ёки насаб танҳо дар он ҳолат имконпазир аст, агар чиптаи баровардашуда ҳуҷҷати airBaltic бошад ва бандкунӣ аз самтҳои парвози аз ҷониби airBaltic иҷрошаванда иборат бошад.',
		'Applicable for tickets booked after 18th of February 2018, for tickets booked before 19th of February, cancellation allowed anytime. A refund fee of 100 EUR applies to each ticket.':
			'Ба ҷиптаҳои баъд аз 18 феврали соли 2018 бандкардашуда татбиқ карда мешавад, ба чиптаҳои баъд аз 19 феврал бандкардашуда, бекоркунӣ дар вақти дилхоҳ иҷозат дода шудааст. Баргардонидани пардохт дар андозаи 100 евро ба ҳар як чипта татбиқ карда мешавад.',
		'For tickets that are purchased until 31.05.2018, a transition period from 01.06.2018-30.06.2018 is applicable. During this period fee is EUR 50.':
			'Барои чиптаҳои то 31.05.2018 харидашуда, давраи гузариш аз 01.06.2018 то 30.06.2018 татбиқ карда мешавад. Дар ин давра пардохт 50 евроро ташкил медиҳад.'
	},
	Consents: {
		agreement_gdsRules: 'бо <a href=\'#\' target=\'_blank\'>шартҳои</a> хизматрасониҳои иловагӣ',
		agreement_insurancesRules: '{{insurancesProductsLinks}}',
		agreement_generalRules: '<span><a href=\'#\' target=\'_blank\'>қоидаҳои харидан</a></span>',
		agreement_interpolation: '{{generalRules}}{{insurancesRules}}{{additionalServiceRules}}',
		agreement_rules:
			'Ман бо {{links}}, пардохти хизматрасониҳои иловагӣ шинос шудам, онҳоро қабул мекунам ва ба онҳо розиям.',
		agreement_additionalInsuranceRules: 'шартҳои офертаи оммавӣ {{link}}',
		agreement_additionalInsuranceName: '«{{name}}»'
	},
	Contacts: {
		'Your contacts': 'Тамосҳо',
		'Contact details are necessary for us to be able to pass on the latest flight information.':
			'Маълумотҳои тамосӣ барои гирифтани иттилоот дар бораи бандкунӣ лозиманд',
		Email: 'Почтаи электронӣ',
		Phone: 'Телефон',
		'We sent SMS with verification code to the phone': 'Коди тасдиқкуниро аз СМС ворид кунед',
		'Didnt get the code? ': 'Кодро нагирифтед? ',
		'Resend it': 'Боз фиристодан',
		Edit: 'Тағйир додан',
		'Invalid code.': 'Коди нодуруст',
		'Want to speed up passenger data entry? Log in and continue.':
			'Барои маҳфуз кардани маълумотҳо ва дафъаи оянда онҳоро такроран ворид накардан аз авторизатсия гузаред ',
		'Want to speed up passenger data entry? Sign up and continue.':
			'Барои маҳфуз кардани маълумотҳо ва дафъаи оянда онҳоро такроран ворид накардан аз қайд гузаред ',
		'Want to speed up passenger data entry?': 'Даровардани маълумотҳо дар бораи мусофиронро тезонидан мехоҳед?',
		'Log in': 'Даромадан',
		'Sign up': 'Аз қайд гузаштан',
		Next: 'Баъдан',
		'You can get the new code in': 'Коди навро фиристодан мумкин аст баъд аз',
		'Sending message...': 'Кодро мефиристем...',
		'Code sent': 'Код фиристода шуд',
		'Welcome!': 'Хуш омадед!',
		'Want to speed up passenger data entry? Sign in and continue.':
			'Ҷараёни бандкуниро тезонидан мехоҳед? Даромадан ба системаро содир кунед.',
		'Continue without signing in': 'Бе даромадан давом додан',
		'Sign in': 'Даромадан',
		'Phone number of the same digits is not allowed': 'Рақами саҳеҳи телефонро ворид кунед',
		'Incorrect phone number': 'Рақами саҳеҳи телефонро ворид кунед',
		'Min 10 digits': 'На кам аз 10 рақам',
		'Max 18 digits': 'На беш аз 18 рақам',
		'Example +1234567890': 'Масалан: +1234567890',
		'Incorrect email': 'Суроғаи саҳеҳи почтаи электрониро ворид кунед',
		Required: 'Сатри ҳатмӣ',
		'Receive a mailing list with promotional offers and discounts':
			'Барои гирифтани мактубҳо бо таҳфифҳо ва пешниҳодҳо ба email розиям'
	},
	CustomerContacts: {
		'Please, enter your contacts': 'Лутфан, маълумоти тамосии худро ворид намоед'
	},
	CustomerContactsForm: {
		'Please, enter your contacts': 'Лутфан, маълумоти тамосии худро ворид намоед',
		Done: 'Омода',
		Email: 'Почта',
		Phone: 'Телефон',
		Required: 'Сатри ҳатмӣ',
		'Please enter a valid email': 'Email-ро тафтиш кунед',
		'Please enter a valid phone': 'Рақами телефонро тафтиш кунед',
		'Please enter a valid FFP': 'Рақами корти садоқатро тафтиш кунед'
	},
	Datepicker: {
		month_0: 'Январ',
		month_1: 'Феврал',
		month_2: 'Март',
		month_3: 'Апрел',
		month_4: 'Май',
		month_5: 'Июн',
		month_6: 'Июл',
		month_7: 'Август',
		month_8: 'Сентябр',
		month_9: 'Октябр',
		month_10: 'Ноябр',
		month_11: 'Декабр',
		week_short_0: 'Дш',
		week_short_1: 'Сш',
		week_short_2: 'Чш',
		week_short_3: 'Пш',
		week_short_4: 'Ҷм',
		week_short_5: 'Шб',
		week_short_6: 'Яш'
	},
	DesktopFlight: {
		Select: 'Итихоб кардан',
		'Select fare': 'Интихоб кардани тарофа',
		Arrival: 'Омадан',
		stop: 'гузариш',
		stops: 'гузаришҳо',
		Nonstop: 'Бевосита',
		Details: 'Тафсилот',
		'Need_f ': 'Лозим ',
		'Need_m ': 'Лозим ',
		'the ability to refund ticket': 'имконияти баргардонидани чипта',
		'the ability to exchange ticket': 'имконияти иваз кардани чипта',
		baggage: 'бағоҷ',
		and: ' ва '
	},
	DesktopFlightInfo: {
		Terminal: 'Терминал',
		Duration: 'Дар роҳ',
		'Arrival the next day': 'Омадан рӯзи дигар',
		'Eco-friendly': 'Eco-friendly',
		'Service is unavailable on this flight': 'Хизмат дар ин самти парвоз расонида намешавад',
		TechnicalLandingIn_0: 'Саворкунии техникӣ дар',
		TechnicalLandingIn_1: 'Саворкуниҳои техникӣ дар',
		'Total duration': 'Вақт дар роҳ',
		'Stop in': 'Гузариш дар',
		'Select from': 'Итихоб кардан аз',
		Select: 'Итихоб кардан',
		from: 'аз',
		Canceled: 'Бекор гардид',
		'taxes and fees': 'Боҷҳо',
		'Operating carrier': 'Самти парвозро иҷро мекунад',
		SubStatus_AwaitingExchange: 'Дар ҷараёни ивазкунӣ',
		SubStatus_Upgrade: 'Дар ҷараён баландкунии дараҷаи хизматрасонӣ'
	},
	DesktopSummaryFlight: {
		'Change flight': 'Интихоб кардани самти парвози дигар',
		'Fare rules': 'Қоидаҳои татбиқи тарофа',
		'Baggage info': 'Иттилоот дар бораи бағоҷ',
		Details: 'Тафсилот',
		Charter: 'Чартерӣ'
	},
	DocumentCardForm: {
		Document: 'Ҳуҷҷат',
		Country: 'Кишвар',
		'Document type': 'Намуди ҳуҷҷат',
		'Document number': 'Рақами ҳуҷҷат',
		'Expiry date': 'Муҳлати эътибор',
		Save: 'Маҳфуз кардан',
		Required: 'Сатри ҳатмӣ',
		Remove: 'Нест кардан'
	},
	EditPassenger: {
		Change: 'Тағйир додан',
		'Passenger information update': 'Тағйирдиҳии маълумотҳои мусофир',
		'Typo correction available': 'Таҳриркунии хатогиҳо дастрас аст',
		'To replace the document or change the surname, it is necessary to attach supporting documents.':
			'Барои ивзкунии ҳуҷҷат ё ки тағйирдиҳии насаб замима кардани ҳуҷҷатҳои тасдиқкунанда талаб карда мешавад.',
		'Attention please!': 'Диққат диҳед!',
		'Due to changes in the data in your order, the air ticket is being exchanged, and the airline cannot guarantee confirmation of previously purchased additional services. All services issued on one electronic document will be canceled, even if you make changes to part of the route. Refunds will be made by the airline according to the terms of the offer.':
			'Вобаста бо тағйирот дар фармоиши шумо ивазкунии чиптаи ҳавопаймоӣ ба амал меояд, ва ширкати ҳавопаймоӣ тасдиқкунии хизматрасониҳои қаблан харидашударо кафолат дода наметавонад. Ҳамаи хизматрасониҳои дар як ҳуҷҷати электронӣ навишташуда, бекор карда мешаванд, ҳатто агар тағйиротро барои қисми хатсайр ба амал бароред ҳам. Баргардонидан маблағ аз ҷониби ширкати ҳавопаймоӣ мутобиқи шартҳои оферта ба амал бароварда мешавад.',
		'Changes for {{name}}': 'Тағйирот барои {{name}}',
		'Your contacts': 'Тамосҳои шумо',
		'A new route receipt will be sent to this address': 'Расиди хатсайрии нав ба ин суроға фиристода мешавад',
		'Request a change': 'Дархост кардани тағйирот',
		'Total to pay': 'Ҳамагӣ ба пардохт',
		'Service price': 'Нархи хадамот',
		Charges: 'Боҷҳо барои мубодила',
		FirstName: 'Номҳо',
		LastName: 'Насабҳо',
		MiddleName: 'Номҳои падар',
		BirthDate: 'Санаҳои таваллуд',
		DocExpiryDate: 'Муҳлатҳои эътибор',
		Gender: 'Ҷинсҳо',
		Nationality: 'Миллатҳо',
		DocType: 'Намудҳои ҳуҷҷат',
		DocNumber: 'Рақамҳои ҳуҷҷат',
		'Delete request': 'Нест кардани дархост',
		'Payment change': 'Пардохт кардан',
		'Create new request': 'Офаридани дархости нав',
		Confirm: 'Тасдиқ кардан',
		Yes: 'Ҳа',
		No: 'Не',
		'The change request was deleted. Want to create a new request?':
			'Дархости ҷорӣ нест карда мешавад. Ба офаридани наваш гузашта шавад?',
		'Rejection reason': 'Сабаби радкунӣ',
		'Comment on the calculation': 'Шарҳ ба ҳисобкунӣ',
		NotificationTitle_AutoMode: 'Баъд аз тасдиқкунӣ ва пардохти дархост мубодилаи чипта ба амал бароварад мешавад.',
		NotificationTitle_ManualMode:
			'Дархости шумо аз ҷониби ширкати ҳавопаймоӣ баррасӣ карда мешавад. Суроғаи почтаи электрониро барои гирифтани огоҳиномаҳо тафтиш кунед.',
		NotificationText_AutoMode:
			'Ҳангоми тағйирдиҳии маълумотҳои мусофир ивазкунии чипта ба амал меояд, ҳуҷҷатҳои нави сафарӣ ба почтаи шумо фиристода мешавад.',
		NotificationText_ManualMode:
			'Ҳангоми тағйирдиҳии маълумотҳои мусофир ивазкунии чипта ба амал меояд, ҳуҷҷатҳои нави сафарӣ ба почтаи шумо фиристода мешавад.',
		ServicesRestriction_Title: 'Хизматрасониҳои иловагии барои ин мусофир навишта шуда, бекор карда мешаванд.',
		ServicesRestriction_Description:
			'Баргардонидан тибқи шартҳои оферда ба амал бароварда мешавад. Маблағҳо барои хизматрасониҳо ба корти ҳангоми харидани чипта истифодашуда, дар давоми 15 рӯз бар мегарданд. Баъд аз анҷоми тағйироти маълумотҳо дар чипта, хизматрасониҳои заруриро боз ба расмият дароред.'
	},
	Exchange: {
		'Change ticket': 'Мубодилаи чипта',
		'Successful payment': 'Пардохти бомуваффақият',
		'Failed payment': 'Пардохт амалӣ нашуд',
		'Add new request': 'Офаридани дархости нав',
		'Select passengers': 'Мусофиронро интихоб кунед',
		Back: 'Ба қафо',
		Next: 'Баъдан',
		'Select flights': 'Самтҳои парвозро интихоб кунед',
		'Select new flight': 'Самти парвози навро интихоб кунед',
		'Open calendar': 'Интихоби сана',
		'You’ve chosen': 'Интихоби шумо',
		Clear: 'Тоза кардан',
		Search: 'Ҷустуҷӯъ',
		'Change flight': 'Иваз кардани парвоз',
		Note: 'Диққат диҳед',
		'Exchange restrictions': 'Маҳдудиятҳои мубодила',
		'The possibility and cost of changes will be calculated by the operator after sending the application. The answer will be sent to your E-mail and is also available on the order page.':
			'Имконияти мубодила ва арзиши он аз ҷониби оператор баъд аз фиристода шудани дархост ҳисоб карда мешавад. Ҷавоб ба email-и шумо фиристода шуда, дар ин саҳифа инъикос мегардад.',
		'After submitting the request, the seats you have selected will be canceled.':
			'Баъд аз фиристодани дархост ҳамаи ҷойҳои интихобшуда дар самти парвоз бекор карда мешаванд.',
		'Create request': 'Офаридани дархост',
		Contacts: 'Офаридани дархост',
		'Your name': 'Номи шумо',
		Email: 'Email',
		'I agree with the': 'Ман розиям бо',
		'Terms of Service': 'қоидаҳои пешкашкунии хидмат',
		And: 'ва',
		'Privacy Policy': 'сиёсати махфият',
		'Your phone': 'Телефони шумо',
		'Your comment': 'Шарҳи шумо',
		'I agree to the Terms of Service and Privacy Policy': 'Ман розиям бо қоидаҳои',
		Request: 'Дархост',
		Create: 'Офарида шуд',
		'Your comments': 'Шарҳи шумо',
		'The cost of changes will be calculated by the operator after choosing the option and sending the request to the operator.':
			'Арзиши мубодила аз ҷониби оператор баъд аз фиристода шудани дархост ҳисоб карда мешавад',
		'Local time indicated': 'Вақти маҳаллӣ',
		'Order must be paid by {{time}} on {{date}}': 'Фармоиш бояд то {{date}} {{time}} пардохт карда шавад',
		InProcess: 'Дар кор',
		NeedConfirm: 'Тасдиқро интизор аст',
		AwaitingPayment: 'Пардохтро интизор аст',
		Finished: 'Анҷом ёфт',
		Rejected: 'Рад карда шуд',
		Refused: 'Баргашта гирифта шуд',
		TimelimitExpired: 'Вақти пардохт гузашт',
		'If you change your mind, or want to create a new request with different parameters, delete this request':
			'Агар аз фикр гашта бошед, ё ки дархости нав офариданӣ бошед, ҷориро нест кунед',
		'Delete request': 'Нест кардани дархост',
		'The change request was deleted. Want to create a new request?':
			'Дархости ҷорӣ нест карда мешавад. Ба офаридани наваш гузашта шавад?',
		Yes: 'Ҳа',
		No: 'Не',
		'Limited exchange time': 'Маҳдудият аз рӯи вақт',
		'Offer valid until {{date}}': 'Пешниҳод то {{date}} амал мекунад',
		'Exchange penalty': 'Ҷаримаҳо ва боҷҳо барои мубодила',
		Total: 'Ҳамагӣ',
		Required: 'Сатри ҳатмӣ',
		'Please, read the rules of service and accept it': 'Лутфан, бо қоидаҳо шинос шавед ва розӣ шавед',
		'Please enter a valid email': 'Email-и саҳеҳро ворид кунед',
		'Please enter a valid phone': 'Телефони саҳеҳро ворид кунед',
		'Whole flight': 'Тамоми парвоз',
		'We couldn\'t find any flights for given dates': 'Мо ба санаҳои интихобшуда самтҳои хатсайрро наёфтем',
		'Please select another date or modify your search. If you wish to purchase a ticket for this particular date, please contact customer support.':
			'Лутфан, санаи дигарро интихоб кунед ё ки ҷустуҷӯи худро тағйир диҳед. Агар чиптаро ба санаи муайян харидан хоҳед, бо хадамоти дастгирии мизоҷон тамос гиред.',
		for: 'барои',
		'Successfully create new booking': 'Фармоиши нав бомуваффақият офарида шуд',
		'View new booking': 'Кушодани фармоиши пайвастгардида',
		'Request for changes': 'Дархост ба мубодила',
		'Payment exchange': 'Пардохт кардан',
		'Oops...': 'Упс...',
		'{{segmentId}}. {{depDate}}, {{airlineCode}}{{flightNumber}}. {{depIata}}({{depTime}}) -> {{arrIata}}({{arrTime}}). Тариф {{tariff}}':
			'{{segmentId}}. {{depDate}}, {{airlineCode}}{{flightNumber}}. {{depIata}}({{depTime}}) -> {{arrIata}}({{arrTime}}). Тарофа: {{tariff}}',
		Refund: 'Ба баргардонидан',
		'All services issued on one electronic document will be canceled, even if you change itinerary partial. Money refund will be carried out by the airline in accordance with the terms of the Puplic Offer':
			'Ҳамаи хизматрасониҳои дар як ҳуҷҷати электронӣ навишташуда, бекор карда мешаванд, ҳатто агар мубодиларо барои қисми хатсайр ба амал бароред ҳам. Баргардонидан маблағ аз рӯи онҳо аз ҷониби ширкати ҳавопаймоӣ мутобиқи шартҳои оферта ба амал бароварда мешавад.',
		'Select type of change': 'Намуди мубодиларо интихоб кунед',
		'Voluntary change': 'Мубодилаи ихтиёрӣ',
		'Involuntary change': 'Мубодилаи маҷбурӣ',
		Voluntary: 'Ихтиёрӣ',
		Involuntary: 'Маҷбурӣ',
		'Back to order': 'Ба фармоиш баргаштан',
		'terms of tariff': 'шартҳои тарофа',
		'Select date for flight {{direction}}': 'Самти парвозро интихоб кунед {{direction}}',
		'If you wish to exchange your ticket, please cancel your flight check-in.':
			'Агар чиптаро баргардонидан хоҳед, пешакӣ бақайдгирӣ ба самти парвозро бекор кунед.',
		'You can do it yourself by going to <a href=\'{{checkInURL}}\' target=\'_blank\'>Online check-in</a>.':
			'Инро ба қисмати <a href=\'{{checkInURL}}\' target=\'_blank\'>Бақайдгирии онлайнӣ</a> гузашта мустақилона кардан мумкин аст.',
		'Either select unused ticket segments for exchange.':
			'Ё ки барои ивазкунӣ сегментҳои чиптаи истифоданашударо интихоб кунед.',
		'It is not possible to exchange the ticket on which the check-in was made for the flight':
			'Мубодилаи чипта, ки аз рӯи он бақайдгирӣ ба самти парвоз имконнопазир аст',
		'It is not possible to exchange a used ticket': 'Мубодилаи чиптаи истифодашуда имконнопазир аст',
		'The ticket has been flown on, you cannot exchange the used ticket':
			'Бо чипта парвоз амалӣ карда шудааст, чиптаи истифодашударо мубодила карда наметавонед.',
		'Partially used ticket can be exchanged only in manual mode':
			'Мубодилаи чиптаи қисман истифодашуда танҳо дар реҷаи дастӣ имконпазир аст',
		'Contact the airline call-center to clarify the conditions of the exchange, as a part of the route was flown. Or select segments of an unused ticket for exchange.':
			'Барои саҳеҳкунии шартҳои мубодила бо маркази тамоси ширкати ҳавопаймоӣ тамос гиред, зеро парвоз дар қисми хатсайр ба амал бароварда шудааст. Ё ки барои ивазкунӣ сегментҳои чиптаи истифоданашударо интихоб кунед.',
		'Part of the route was flown, part of the ticket is used. The application for exchange will be considered manually by the airline':
			'Парвоз дар қисми хатсайр ба амал бароварда шудааст, қисми чипта истифодашуда мебошад. Дархост ба мубодила аз ҷониби ширкати ҳавопаймоӣ дар реҷаи дастӣ баррасӣ карда мешавад',
		'Select new date': 'Санаи навро интихоб кунед',
		'Select date': 'Санаро интихоб кунед'
	},
	FareConditions: {
		'Try again': 'Боз кӯшиш кардан',
		'Internal error': 'Хатогии дохилӣ',
		Sheremetyevo: 'Шереметево',
		Riga: 'Рига',
		Original: 'Оригинал',
		'Translate to russian*': 'Ба русӣ тарҷума кардан*',
		'Fare conditions': 'Шартҳои тарофа',
		'from 12 years': 'аз 12 сола',
		'from 2 to 12 years': 'аз 2 то 12 сола',
		'without seat': 'бе ҷой',
		'Fare code': 'Коди тарофа',
		'See more details on this page': 'Шартҳои муфассал'
	},
	FareGroup: {
		Select: 'Итихоб кардан',
		Unavailable: 'Дастнорас',
		Recommended: 'Хити фурӯшҳо',
		'Compare fare families': 'Муқоисаи тарофаҳо',
		Choose: 'Итихоб кардан',
		Rules: 'Қоидаҳо',
		Taxes: 'Боҷҳо',
		'Not enough miles on your card': 'Дар корти шумо миляҳо кифоя нестанд'
	},
	FareLock: {
		'Fixation the cost of the air ticket': 'Муқарраркунии арзиши чиптаи ҳавопаймо',
		'Check your selection and pay fare lock': 'Интихоби худро тафтиш кунед ва ба пардохт гуҳаред',
		'If you make the decision to fly on the selected date within the next {{hours}} {{plural}}, you will be able to pay the full amount of the booking at the fare you locked in. Please, be advised that Fare lock fee is non-refundable.':
			'Агар оиди паридан дар санаи интихобшуда дар давоми {{hours}} {{plural}} қарор қабу кунед, арзиши пурраи бандкуниро аз рӯи тарофае, ки ях кунонидед, пардохт карда метавонед. Диққат диҳед, ки пардохти яхкунонии тарофа баргардонида намешавад.',
		'No need to worry about the price increase or about the fact that all tickets will be sold out, now you can fix the ticket price for {{hours}} {{plural}}':
			'Оиди баландшавии нарх ё ки аз он, ки ҳамаи чиптаҳоро мехаранд, ташвиш кашидан лозим нест, ҳоло нархи чиптаи ҳавопаймоиро ба {{hours}} {{plural}} соат банд карда метавонед.',
		hours_0: 'соат',
		hours_1: 'соат',
		hours_2: 'соат',
		hours_genitive_0: 'соати',
		hours_genitive_1: 'соатҳои',
		hours_genitive_2: 'соатҳои',
		Add: 'Ях кунонидан',
		only: 'Ҳамагӣ',
		'Confirmed fare lock': 'Яхкунонии тарофа'
	},
	FlightCard: {
		Flight: 'Самти парвоз',
		Duration: 'Дар роҳ',
		'The flight operates': 'Самти парвозро иҷро мекунад'
	},
	FlightInfo: {
		Details: 'Тафсилоти парвоз'
	},
	FlightInfoModalContent: {
		'You choose': 'Мо интихоб кардем',
		'Back to flights': 'Баргаштан ба парвозҳо',
		'Total duration': 'Давомнокии умумӣ',
		'Scroll up': 'Ба боло',
		'Compare fares': 'Муқоисаи тарофаҳо',
		'Fare rules': 'Қоидаҳои татбиқи тарофа',
		'Select your bundle': 'Тарофаро интихоб кунед',
		Economy: 'Эконом',
		Business: 'Бизнес',
		Premium: 'Премиалӣ',
		'Flight info': 'Иттилоот дар бораи парвоз',
		'More details': 'Тафсилоти бештар',
		'comfortable salon': 'Салони боҳаловат',
		'access to wifi': 'Дастрасӣ ба wifi',
		'View full conditions': 'Муқоисаи тарофаҳо',
		'hot and children\'s menu': 'Ғизои гарм',
		'comfortable seating': 'Аз қайд гузаштани ройгон',
		'access to airport lounge': 'Интихобкунии ройгони ҷой',
		'meals are included in the price': 'Ғизо ворид карда шудааст',
		'premium fare': 'Тарофаҳои премиалӣ',
		Selected: 'Интихоб шуд',
		'SelectedFareGroup_View full conditions': 'Муқоисаи тарофаҳо',
		Back: 'Ба қафо'
	},
	FlightPrice: {
		from: 'аз',
		'NO SEATS': 'ҶОЙҲО НЕСТАНД',
		Economy: 'Эконом',
		Light: 'Лайт',
		Classic: 'Классик',
		Flex: 'Чандир',
		Business: 'Бизнес',
		Premium: 'Премиум',
		'Select from': 'Интихоб кардан аз',
		Select: 'Интихоб кардан',
		'taxes and fees': 'Боҷҳо',
		'Subsidized flight': 'Субсидияшуда',
		'A subsidized fare requires all passengers on the booking to have benefits.':
			'Истифодабарии тарофаи субсидияшуда имконпазир аст, агар ҳамаи мусофирон дар фармоиш ҳуқуқ ба имтиёзро дошта бошанд',
		left: 'боқӣ монд',
		left_0: 'боқӣ монд',
		tickets: 'чипта',
		tickets_1: 'чипта',
		tickets_2: 'чиптаҳо',
		'{{count}} {{ticket}} {{left}}': '{{left}} {{count}} {{ticket}}',
		'Special conditions for flight delays and ticket refunds':
			'Тарофаҳои махсус ҳангоми таъхири самти парвоз ва баргардонидани чиптаҳо',
		'Full conditions': 'Шартҳои пурра',
		'Transit tariff': 'Тарофаи транзитӣ'
	},
	FlightSortFilter: {
		Sort: 'Банавъҷудокунӣ',
		'Price Graph': 'Нақшаи нархҳо'
	},
	FlightsListControls: {
		Filter: 'Ҷустуҷӯъ',
		Nonstop: 'Бе гузаришҳо',
		'Flight Num': 'Рақами парвоз',
		'Enter airline code or flight number': 'Коди ширкати ҳавопаймоӣ ё ки рақами парвозро ворид кунед',
		Schedule: 'Ҷадвал'
	},
	Forms: {
		Search: 'Ҷустуҷӯъ',
		'My booking': 'Дастрасӣ ба бандкунӣ',
		Checkin: 'Бақайдгирии онлайнӣ',
		'Ticket number': 'Рақами чипта',
		'Order number': 'Рақами чипта ё ки фармоиш',
		'Last name': 'Насаби мусофир',
		Find: 'Ёфтан',
		Continue: 'Давом додан',
		'To check in for a Smartavia flight, please visit their official website':
			'To check in for a Smartavia flight, please visit their official website'
	},
	FullscreenDialog: {
		Close: 'Пӯшидан'
	},
	GuardedApolloProvider: {
		'Ops...': 'Ой...',
		'Unfortunately, something went wrong. Please try again or contact with us':
			'Мутаассифона, чизе нодуруст шуд. Лутфан, барои дертар такрор кардан кӯшиш кунед',
		Close: 'Пӯшидан',
		'The service is temporarily unavailable. It is possible that the order is open on another device/browser or being handled by an airline specialist. Please try again later.':
			'Хадамот муваққатан дастнорам аст, эҳтимол, фармоиш дар дастгоҳи/браузери дигар кушода шудааст ё ки бо он мутахассиси ширкати ҳавопаймоӣ кор мекунад. Барои дертар такрор кардан кӯшиш кунед'
	},
	IncludedBaggage: {
		Included: 'Ворид аст',
		there: 'ба он ҷо',
		return: 'бозгашт',
		'round trip': 'ба ҳамаи самтҳои парвоз',
		Upgrade: 'Беҳтар кардан',
		included: 'ворид аст',
		'Whole route': 'Тамоми роҳ',
		'Choose for each flight': 'Алоҳида ба ҳар як самти парвоз',
		'Price per flight': 'Нарх барои парвоз',
		'Price for all flights': 'Нарх барои тамоми парвоз',
		Cancel: 'Бекор кардан',
		Confirm: 'Тасдиқ кардан',
		Total: 'Ҳамагӣ',
		Clear: 'Тоза кардан',
		'Added for all flights': 'Ба тамоми хатсайр',
		Equipment: 'Таҷҳизот',
		'Need to bring sports, music or baby equipments?':
			'Ба шумо бо худ гирифтани таҷҳизоти варзишӣ, мусиқӣ ё ки аробачаи кӯдакона гирифтан лозим аст?',
		'All flights': 'Ҳамаи самтҳои парвоз',
		from: 'аз',
		total: 'ҳамагӣ',
		Edit: 'Тағйир додан',
		Add: 'Илова кардан',
		'Up to': 'То'
	},
	IncludedOptions: {
		Included: 'Ворид аст',
		'Baggage rules': 'Қоидаҳои кашонидани бағоҷ',
		'Upgrade cabin baggage': 'Бори дастӣ',
		'Get {{upgradedCabinBaggage}} of cabin baggage onboard, instead of {{includedCabinBaggage}}':
			'{{upgradedCabinBaggage}} бори дастӣ ба ҷойи {{includedCabinBaggage}}',
		pc: 'дона',
		kg: 'кг',
		with: 'тарофа',
		Change: 'Тағйир додан',
		Upgrade: 'Илова кардан'
	},
	InfoCard: {
		document: 'Ҳуҷҷат',
		'Frequent Flyer programm': 'Корти садоқат',
		passport: 'Шиноснома',
		'International passport': 'Шиносномаи хориҷӣ',
		Number: 'Рақам',
		'Expiry date': 'Муҳлати эътибор',
		Delete: 'Нест кардан',
		Edit: 'Таҳрир кардан',
		Add: 'Илова кардан',
		'dd.mm.yyyy': 'рр.мм.сссс'
	},
	InsurancePage: {
		'You lose protection and peace of mind in unforeseen situations.': 'Суғурта интихоб карда нашудааст',
		'Buy insurance': 'Гирифтани пардохтҳои суғуртавӣ',
		'I assume all risks and Cancel insurance': 'Пардохтҳои суғуртавиро рад мекунам',
		'Insure your flight': 'Суғуртаро интихоб кардан лозим аст',
		'To make your travels memorable only with pleasant excitement, take out an insurance policy that will protect you during your trip.':
			'Барои он, ки саёҳати шумо танҳо бо ҳаяҷони форам дар хотир монад, полиси суғуртаро ба расмият дароред, ки шуморо дар вақти сафар муҳофиза мекунад.',
		'For all passengers': 'Барои ҳамаи мусофирон',
		Remove: 'Нест кардан',
		from: 'аз',
		'I want protect my trip.': 'Дар ҳолати суғуртавӣ пардохт гирифтан мехоҳам',
		'I do not want to insure my life or luggage and assume all risks':
			'Парвоз бе суғурта. Ҳамаи хароҷоти вобаста бо ҳолатҳои ғайричашмдоштро мустақилона пардохт мекунам',
		'More details': 'Тафсилот',
		'Choice of insurance': 'Интихобкунии суғурта',
		'Back to services': 'Баргаштан ба хадамотҳо',
		Cancel: 'Бекор кардан',
		Confirm: 'Тасдиқ кардан',
		InsuranceUpsaleMainDescription:
			'Дар ҳолати муаммоҳо бо бағоҷ, таъхир ё ки бекор карда шудани самти парвоз, инчунин ҳангоми хароҷотҳои иловагии тиббӣ ё ки ҳодисаи нохуш пардохтҳо намегиред.',
		InsuranceUpsaleAdditionalDescription:
			'Ба ҳисоби миёна арзиши полиси суғурта 0,1% аз хароҷоти имконпазир дар ҳолати ба миён омадани ҳолатҳои ғайричашмдоштро ташкил медиҳад. Сайёҳои ботаҷриба ҳамеша суғуртаро харидорӣ мекунанд, то ки диққатро ба мақсадҳои сафар ҷамъ кунанд ва худро аз хароҷоти зиёдатӣ озод намоянд.',
		'Most popular': 'Интихоб кардани мусофирон',
		'Download police': 'Боргирӣ кардани полис',
		Add: 'Илова кардан'
	},
	Loader: {
		loading: 'боркунӣ'
	},
	Location: {
		Terminal: 'Терминал',
		Details: 'Тафсилот'
	},
	LocationAutocomplete: {
		'Recent searches': 'Ҷустуҷӯ карда будед',
		'show all directions': 'ҳамаашро нишон додан',
		'Sorry, we do not fly': 'Самтҳои парвоз нестанд',
		from: 'аз',
		to: 'дар',
		'Nearby airports': 'Фурудгоҳҳои наздиктарин',
		'Popular airports': 'Самтҳои машҳур',
		'Perhaps you are looking for': 'Эҳтимол, ҷустуҷӯ карда бошед',
		Stop_0: 'Гузариш',
		Stop_1: 'Гузаришҳо',
		Stop_2: 'Гузаришҳо',
		From: 'Аз куҷо',
		To: 'Ба куҷо',
		'Enter city or country': 'Шаҳр ё ки кишварро ворид кунед',
		'Pick a country': 'Кишварро интихоб кунед',
		'Pick a city': 'Шаҳрро интихоб кунед'
	},
	LoginPage: {
		'Log in': 'Даромадан',
		Required: 'Сатри ҳатмӣ',
		'Please enter a valid Email / Phone / Card number':
			'Лутфан, Почтаи электронӣ / Телефон / Рақами кортро ворид кунед',
		'Email / Phone / Card number': 'Почтаи электронӣ / Телефон / Рақами корт',
		'or with you social network': 'даромадан тавассути шабакаи иҷтимоӣ',
		'Please, read the rules of service and accept it':
			'Барои давом додан, лутфан, розигии худро барои коркарди маълумотҳои шахсӣ тасдиқ кунед',
		'Welcome!': 'Хуш омадед!',
		'You are logged in for the first time, please read the terms and conditions and give consent':
			'Агар ба система аввалин маротиба даромада бошед, лутфан, бо шартҳо розӣ шавед ва розигӣ ба коркарди маълумотҳои шахсиро тасдиқ кунед',
		'I agree to the': 'Розигӣ медиҳам ба',
		'Terms of Service and Privacy Policy': 'коркарди маълумотҳои шахсии ман',
		'An e-mail with code has been sent to you.': 'Ба шумо мактуб бо код фиристода шуда буд',
		'Code sent to your phone.': 'Код ба телефони шумо фиристода шуд',
		'Please, check the code': 'Дурустии коди ворид карда шударо тафтиш кунед',
		'Didn\'t get the code?': 'Кодро нагирифтед?',
		'Resend it': 'Кодро такроран равона кардан',
		'Welcome back,': 'Хуш омадед,',
		'Welcome back!': 'Хуш омадед!',
		'Enter code': 'Коди тасдиқкуниро ворид кунед',
		'Verification code': 'Коди тасдиқкунӣ',
		Continue: 'Давом додан',
		'Enter code_FFP': 'Рамзро ворид кунед',
		'Verification code_FFP': 'Рамз',
		Continue_FFP: 'Даромадан',
		'Enter code_Email': 'Коди тасдиқкуниро ворид кунед',
		'Verification code_Email': 'Коди тасдиқкунӣ',
		Continue_Email: 'Давом додан',
		'Enter code_Phone': 'Коди тасдиқкуниро ворид кунед',
		'Verification code_Phone': 'Коди тасдиқкунӣ',
		Continue_Phone: 'Давом додан',
		'If you don\'t have an account, it will be created automatically':
			'Агар аккаунт надошта бошед — он ба таври худкор офарида мешавад',
		'Remember me': 'Маро дар хотир нигоҳ доштан',
		N4_FirstLoginAgreement_Checkbox_Label_1:
			'Ман ба <a target="_blank" rel="noopener noreferrer" href="https://nordwindairlines.ru/tg/legal/privacy-policy#pers">шартҳои коркарди маълумоти шахсиям</a> розӣ ҳастам',
		N4_FirstLoginAgreement_Checkbox_Label_2:
			'Ман бо <a target="_blank" rel="noopener noreferrer" href="https://nordwindairlines.ru/tg/legal/privacy-policy#poly">сиёсати коркарди маълумоти шахсиям</a> шинос шудам'
	},
	Loyalty: {
		'Log in to LightJet Club': 'Даромадан ба утоқи шахсии Websky Club',
		'Forgot password?': 'Рамзро фаромуш кардед?',
		Step: 'Қадам',
		'Enter your email': 'Email-и худро ворид кунед',
		Back: 'Ба қафо',
		Continue: 'Давом додан',
		'Profile not found. Check spelling your e-mail address': 'Профил ёфт нашуд. Дурустии email-ро ворид кунед',
		'Enter code': 'Кодро ворид кунед',
		'The verification code has been sent to the email': 'Коди тасдиқкунӣ ба email фиристода шуд',
		'Verification code': 'Калид',
		'You entered an incorrect code': 'Коди нодуруст',
		'Password reset': 'Рамз тағйир дода шуд',
		'A new password has been sent to your e-mail': 'Рамзи нав ба email-и шумо равона карда шуда буд',
		'Back to login': 'Даромадан',
		Required: 'Сатри ҳатмӣ',
		'Card number': 'Рақами корт',
		Password: 'Рамз',
		'Not a member yet? Join for free!': 'Ҳоло корт надоред? Ройгон аз қайд гузаред!',
		'Create account': 'Офаридани аккаунт',
		'I have a card': 'Аллакай корт дорам',
		Create: 'Офаридан',
		'Data was sent to your email': 'Маълумотҳо почта фиристода шуданд',
		'You successfully created account. Check your email to sign in':
			'Шумо дар барномаи садоқат бомуваффақият корт офаридед. Маълумотҳо барои даромадан ба утоқ email-и шумо фиристода шуда буданд.',
		'Log in to account': 'Ба аккаунт даромадан',
		'Your status': 'Мавқеъи шумо',
		'Ops...': 'Упс...',
		'Connect to loyalty program with your card': 'Профили худро ба барномаи садоқат илова кунед',
		'Incorrect card number or password': 'Рақами нодурусти корт ё ки рамз',
		'Please enter your card number': 'Сатри ҳатмӣ',
		'Enter password': 'Сатри ҳатмӣ',
		red: 'Red',
		silver: 'Silver',
		gold: 'Gold',
		platinum: 'Platinum',
		miles: 'миля',
		'miles left for': 'миля монд то',
		'Left for gold status': 'То мавқеъи тиллоӣ',
		'Left for silver status': 'То мавқеъи нуқрагӣ',
		'Left for platinum status': 'То мавқеъи платинавӣ',
		About: 'Муфассалтар',
		'Miles recovery': 'Барқарор кардани парвозҳо',
		'Use miles': 'Истифода бурдани миляҳо',
		Promotions: 'Иқдомҳо',
		'Promo-code': 'Промо-кодҳо',
		'E-voucher': 'Купон',
		expiry: 'ба анҷом мерасад',
		expired: 'ба анҷом расид',
		Connect: 'Пайваст кардан',
		'Get promo code': 'Гирифтани промо код',
		Get: 'Гирифтан',
		Conditions: 'Шартҳо',
		'How to get': 'Чӣ тавр гирифтан',
		'How to use': 'Чӣ тавр истифода бурдан',
		Active: 'Фаъолҳо',
		Expired: 'ба анҷом расидаҳо',
		Total: 'Ҳамагӣ',
		'Exit and add another card': 'Баромадан ва илова кардани корти дигар',
		'You sure?': 'Боварӣ доред?',
		'Delete card from your account?': 'Корт аз аккаунти шумо нест карда шавад?',
		No: 'Не',
		Yes: 'Ҳа',
		or: 'ё ки',
		flights: 'парвозҳо',
		'Cannot create an account': 'Хатогӣ ҳангоми офаридани аккааунт',
		'Registration of persons under the age of 14 in the loyalty program is prohibited':
			'Дар барномаи садоқат танҳо аз 14 солагӣ аз қайд гузаштан мумкин аст',
		Close: 'Пӯшидан',
		'out of': 'аз',
		'Left {{miles}} for {{level}} status': '{{miles}} миля то мавқеъи {{level}} монд',
		'Start saving now':
			'Сарфакуниро ҳозир оғоз намо! Миляҳоро ба даст оред ва онҳоро ба хатсайрҳои наздиктарин сарф кунед.',
		Registration: 'Аз қайд гузаштан',
		Statuses: 'Мавқеъҳо',
		Earn: 'Ҷамъ кардан',
		'Earn miles': 'Ҷамъ кардани миляҳо',
		Status: 'Мавқеъ',
		Use: 'Сарф кардан',
		FAQ: 'Саволҳои зуд-зуд',
		'Please wait, we are updating information about your loyalty card. It make take a  few minutes...':
			'ЛУтфан, интизор бошед, мо иттилоот дар бораи корти садоқати шуморо нав мекунем. Ин якчанд дақиқаро гирифта метавонад',
		'To continue registering in the loyalty system, fill out and confirm your email in your personal account.':
			'Барои давом додани дар системаи садоқат аз қайд гузаштан, пур кунед ва email-и худро дар утоқи шахсӣ тасдиқ кунед',
		'Fill email': 'Пур кардани почта',
		'This auth type is already being used in another account':
			'Ин корт аллакай дар аккаунти дигар истифода бурда мшавад',
		'The use of a loyalty card is prohibited': 'Истифода бурдани ин корт манъ аст',
		'You have reached the maximum level in the loyalty program!':
			'Шумо дар барномаи садоқат ба сатҳи баландтарин расидед!',
		'We are grateful for your trust and are pleased to inform you that you are now using our services on the most favorable terms.':
			'Мо аз шумо барои боварӣ миннатдорем ва аз хабар додани он шодем, ки шумо акнун аз хизматрасониҳо бо шартҳои муфидтарин истифода мебаред.',
		'Congratulations!': 'Табрик!',
		'You have reached the final top level!': 'Шумо ба дараҷаи баландтарин расидед!'
	},
	LoyaltyBonus: {
		'LightJet Club': 'Websky Club',
		miles: 'миля',
		'You will get for this flight': 'Барои ин парвоз мегиред',
		'Fly with us and get bonuses!': 'Бо мо парвоз кунед ва бонусҳо гиред!'
	},
	LoyaltyCardForm: {
		'Frequent Flyer': 'Корти садоқат',
		'Frequent Flyer Programm': 'Барномаҳои корти садоқат',
		'Document number': 'Рақам',
		Save: 'Маҳфуз кардан',
		Required: 'Сатри ҳатмӣ'
	},
	Meal: {
		Add: 'Илова кардан',
		Select: 'Интихоб кардан',
		Clear: 'Тоза кардан',
		Done: 'Омода',
		g: 'г',
		Allergens: 'Аллергенҳо',
		Free: 'Ройгон',
		'Show description': 'Муфассалтар',
		Total: 'Ҳамагӣ',
		'Add for all': 'Барои ҳама илова кардан'
	},
	MealPage: {
		'Meals on board': 'Ғизо дар борт',
		'Feel the taste in flight': 'Таъмро дар парвоз эҳсос намоед\n\n\n',
		Meal: 'Ғизо'
	},
	MealService: {
		All: 'Ҳамаи таъомҳо',
		'Select menu': 'Таъомномаро интихоб кунед',
		serving_0: '{{count}} порс',
		serving_1: '{{count}} порс',
		serving_2: '{{count}} порс',
		select: 'итихоб кардан',
		'Terms & conditions': 'Шартҳои пешкашкунии ғизо',
		Unavailable: 'Дастнорас',
		'Selected dishes': 'Таъомҳои интихобшуда'
	},
	MetasearchLoader: {
		'Checking seats availability': 'Мавҷудияти ҷойҳои озодро тафтиш мекунем',
		'Just a few seconds...': 'Ин ҳамагӣ якчанд сонияро мегирад...',
		'Booking service is temporary unavailable': 'Хадамоти бандкунӣ муваққатан дастнорас аст',
		'Please reload the page': 'Лутфан, саҳифаро нав кунед',
		Reload: 'Нав кардан'
	},
	MilesRecovery: {
		'Miles recovery': 'Барқароркуни миляҳо',
		'Please note that miles recovery is possible': 'Диққат диҳед, ки барқароркунии миляҳо имконпазир аст:',
		MoreThanSixMonthsFlights: 'танҳо аз рӯи парвозҳои содиркардашуда',
		OnlyCompletedFlights: 'барои парвозҳои на бештар аз 6 моҳ қабл содиргардида',
		'Ticket number': 'Рақами чипта',
		Create: 'Офаридани дархост',
		'Passenger surname': 'Насаби мусофир',
		Required: 'Сатри ҳатмӣ',
		'Order not found': 'Фармоиш ёфт нашуд',
		'Enter your ticket number': 'Рақами чиптаро ворид кунед',
		'Invalid date': 'Санаи саҳеҳро нишон диҳед',
		'Flight date': 'Санаи парвоз',
		'Flight number': 'Рақами самти парвоз',
		'Pick a flight date': 'Санаро самти парвозро интихоб кунед'
	},
	MobileAuthForm: {
		'Sign in': 'Ба система дароед',
		'and fill in passengers info with a single click': 'ва маълумотҳои мусофиронро дар як клик ворид кунед',
		'Sign in with email': 'Бо ёрии почтаи электронӣ даромадан',
		'Continue as a guest': 'Ҳамчун меҳмон давом додан'
	},
	MobileSegmentInfo: {
		Nonstop: 'Бевосита',
		'More info': 'Муфассалтар',
		stop: 'гузариш',
		in: 'дар',
		Terminal: 'Терминал'
	},
	MobileSelectedFare: {
		'You selected': 'Мо интихоб кардем',
		'Compare fare families': 'Муқоисаи тарофаҳо',
		'Fare conditions': 'Шартҳои тарофа',
		Free: 'Ройгон',
		'Fare rules': 'Қоидаҳои татбиқи тарофа',
		'Baggage info': 'Маълумот оиди бағоҷ'
	},
	MobileStepbar: {
		Flights: 'Парвоз',
		Passengers: 'Мусофирон',
		'Onboard Services': 'Хизматрасонӣ дар борт',
		Extras: 'Хизматрасониҳои иловагӣ',
		Payment: 'Пардохт',
		Add: 'Илова кардан',
		Total: 'Ҳамагӣ',
		Economy: 'Эконом класс',
		Business: 'Бизнес класс',
		Adult: 'Калонсол',
		Child: 'Кӯдак',
		Infant: 'Навзод',
		'Infant with seat': 'Навзод бо ҷой',
		Details: 'Тафсилот',
		Change: 'Тағйир додан',
		ADT: 'Калонсол',
		CLD: 'Кӯдак',
		INF: 'Навзод',
		INS: 'Навзод бо ҷой',
		M: 'Мард',
		F: 'Зан',
		Contact: 'Тамосҳо',
		'Not selected': 'Интихоб нашуд',
		Free: 'Ройгон'
	},
	MobileSummaryFlight: {
		Returning: 'Бозгашт',
		Departing: 'Ба он ҷо',
		'taxes and fees': 'Боҷҳо'
	},
	MobileToolbar: {
		Back: 'Ба қафо',
		Continue: 'Давом додан'
	},
	ModalConfirm: {
		Cancel: 'Бекор кардан',
		Confirm: 'Тасдиқ кардан'
	},
	OrderCard: {
		'Booking ID': 'Коди бандкунӣ',
		Open: 'Кушодан',
		'Security code': 'Коди дастрасӣ',
		Passengers: 'Мусофирон',
		Details: 'Тафсилот',
		Transactions: 'Амалиётҳо',
		Download: 'Боргирӣ кардан',
		Confirmed: 'Пардохт шуд',
		'The order must be paid today': 'Пардохтро интизор аст имрӯз то',
		'The order must be paid at': 'Пардохтро интизор аст то',
		'Online check-in started': 'Онлайн чекин кушода',
		'Tickets have been sent to {{email}}': 'Чиптаҳо ба {{email}} фиристода шуданд',
		'Send tickets to the email?': 'Чиптаҳо ба почта фиристода шаванд?',
		Booked: 'Банд карда шуд',
		Cancelled: 'Бекор карда шуд',
		Total: 'Ҳамагӣ',
		'Changed your plans?': 'Нақшаҳо тағйир ёфтанд?',
		Exchange: 'Иваз кардан',
		Refund: 'Баргардонидан',
		'Review:Waiting for payment': 'Пардохтро интизор аст',
		'Review:Expires at': 'Ба анҷом мерасад',
		'Review:Expires today at': 'Ба анҷом мерасад имрӯз то',
		'Account:Waiting for payment': 'Пардохтро интизор аст',
		'Account:expires at': 'Ба анҷом мерасад',
		'Account:expires today at': 'Ба анҷом мерасад имрӯз то',
		'Check-in': 'Бақайдгирии онлайнӣ',
		'Resend it': 'Боз фиристодан',
		'Passengers details': 'Маълумот дар бораи мусофирон',
		'Expired date': 'Муҳлати эътибор',
		Gender_male: 'Мардона',
		Gender_female: 'Занона',
		'Additional information': 'Иттилооти иловагӣ',
		Change: 'Тағйир додан',
		Accompanying: 'Ҳамроҳикунанда',
		accompanies: 'ҳамроҳӣ мекунад',
		'Select an adult for accompany': 'Ҳамроҳикунандаи болиғро интихоб кунед',
		'After selecting a new adult, please double-check all services. Please choose an adult who does not sit on the emergency seat row.':
			'Баъд аз интихоби калонсоли нав, лутфан, ҳамаи хизматрасониҳои фармоишдодашударо аз нав тафтиш кунед. Лутфан, калонсолро, ки на дар қатори садамавии курсиҳо менишинад, интихоб кунед.',
		Confirm: 'Тасдиқ кардан',
		'Change link to adult': 'Тағйир додани пайваст ба калонсол',
		'Oops...': 'Упс...',
		'An error occurred while executing the request. Please try again later or contact a customer support service.':
			'Ҳангоми иҷрокунии дархост хатогӣ рух дод Такроран кӯшиш кунед ё ки бо хадамоти дастгирии мизоҷон тамос гиред.',
		OK: 'OK',
		DeleteFromList: 'Аз рӯихат нест кардан',
		BookingRemoval: 'Несткунии бандкунӣ',
		BookingRemovalMessage: 'Бандкунии {{orderLocator}} аз рӯихат нест карда мешавад',
		Remove: 'Нест кардан',
		Cancel: 'Бекор кардан'
	},
	OrderChangeHistoryModal: {
		History: 'Таърих',
		'Loading...': 'Боркунӣ...',
		'History is empty': 'Таърих холӣ аст',
		Time: 'Сана/Вақт',
		Action: 'Амал'
	},
	OrderSummary: {
		Booking: 'Коди бандкунӣ',
		'Security code': 'Коди дастрасӣ',
		from: 'аз',
		to: 'дар',
		Manage: 'Дидати тафсилот',
		'Currently there are no active bookings made through your private profile.':
			'Шумо ҳоло ягон бандкуниро содир накардед.',
		'Search flight': 'Ҷустуҷӯи самтҳои парвоз',
		'I have a booking': 'Иловакунии фармоиш',
		'Check-in': 'Бақайдгирии онлайнӣ',
		Download: 'Боргирӣ кардан',
		'For accessing booking page from another device': 'Барои гирифтани дастрасӣ ба фармоиш аз дастгоҳи дигар',
		'Waiting for payment': 'Пардохт кардан лозим аст',
		'expires at': 'то',
		'expires today at': 'имрӯз то',
		'Time to complete booking has expired': 'Вақти пардохт гузашт'
	},
	Page404: {
		'Destination unknown': 'Ба ин ҷо парвоз намекунем',
		'PAGE NOT FOUND': 'САҲИФА ЁФТ НАШУД',
		'Take me home': 'Ба асосӣ баргаштан'
	},
	Passenger: {
		Adult: 'Калонсол',
		Child: 'Кӯдак',
		Infant: 'Навзод',
		'Infant with seat': 'Навзод бо ҷой',
		phone: 'Телефон',
		email: 'Почтаи электронӣ',
		latinFirstName: 'Ном (бо ҳуруфи лотинӣ)',
		latinLastName: 'Насаб (бо ҳуруфи лотинӣ)',
		latinMiddleName: 'Номи падар (бо ҳуруфи лотинӣ)',
		docIssued: 'Санаи додани ҳуҷҷат',
		docIssuedBy: 'Коди мақомоте, ки ҳуҷҷатро додааст',
		city: 'Шаҳр',
		country: 'Кишвар',
		firstName: 'Ном',
		lastName: 'Насаб',
		middleName: 'Номи падар',
		birthDate: 'Санаи таваллуд',
		gender: 'Ҷинс',
		nationality: 'Шаҳрвандӣ',
		docType: 'Намуди ҳуҷҷат',
		docNumber: 'Рақами ҳуҷҷат',
		docExpiryDate: 'Муҳлати эътибор',
		loyaltyName: 'Корти садоқат',
		loyaltyNumber: 'Рақами корти садоқат',
		Passenger: 'Мусофир',
		'Onboard services': 'Хизматрасонӣ дар борт',
		'Latin symbols and digits': 'Ҳарфҳои лотинӣ ва ҳарфҳо',
		'Enter date in dd.mm.yyyy format': 'Санаи саҳеҳро ворид кунед',
		'Incorrect date': 'Санаи носаҳеҳ',
		'Date expired': 'Муҳлати эътибор гузаштааст',
		Edit: 'Тағйир додан',
		Required: 'Сатри ҳатмӣ',
		Passport: 'Шиноснома',
		MilitaryIDCard: 'Билети ҳарбӣ',
		DocOfPassportLusing: 'Шаҳодатномаи муваққати шахсият',
		'ReleaseCertificate ': 'Маълумотнома дар бораи озодшавӣ барои шахсони озодшуда',
		'ServicePassport ': 'Шиносномаи хизматӣ',
		'FederalParliamentDeputy ': 'Шаҳодатномаи депутати шӯрои федератсияҳо ё ки думаи давлатӣ',
		DiplomaticPassport: 'Шиносномаи дипломатӣ',
		InternationalPassportNotRU: 'Шиносномаи хориҷӣ',
		InternationalPassportRU: 'Шиносномаи хориҷӣ',
		InternationalPassport: 'Шиносномаи хориҷӣ',
		NationalPassport: 'Шиносномаи миллӣ',
		SeamanDocument: 'Шинономаи баҳрнавард',
		SeniorDocument: 'Шаҳодатномаи нафақа',
		BirthRegDocument: 'Шаҳодатнома дар бораи таваллуд',
		CertificateOfConvictedVacation: 'Шаҳодатномаи шахсият',
		ResidencePermit: 'Иҷозатномаи иқомат',
		'Only letters are allowed': 'Аломатҳои иҷозатдодашуда ворид карда шуданд',
		'Phone number of the same digits is not allowed': 'Рақами саҳеҳи телефонро ворид кунед',
		'Incorrect phone number': 'Рақами саҳеҳи телефонро ворид кунед',
		'Min 10 digits': 'На кам аз 10 рақам',
		'Max 18 digits': 'На беш аз 18 рақам',
		'Example +1234567890': 'Масалан: +1234567890',
		'Only digits': 'Танҳо рақамҳо',
		'11 digits': '11 рақамро ворид кунед',
		'10 digits': '10 рақамро ворид кунед',
		'9 digits': '9 рақамро ворид кунед',
		'No less then 5 digits': 'На камтар аз 5 рақам',
		'Incorrect email': 'Суроғаи саҳеҳи почтаи электрониро ворид кунед',
		'Invalid date format': 'Санаи саҳеҳро ворид кунед',
		'Example: IVШЯ123123': 'Масалан: IVШЯ123123',
		'Example: IIIШЯ352007, 5465467': 'Масалан: IIIШЯ352007, 5465467',
		'Example: AN0123456': 'Масалан: AN0123456',
		'Cyrillic symbols are not allowed': 'Танҳо ҳарфҳои лотинӣ',
		identity: 'Маълумотҳо дар бораи мусофирон',
		citizenship: 'Ҳуҷҷат',
		loyalty: 'Барномаи садоқат',
		contacts: 'Тамосҳо',
		'Don\'t have a card yet? Register now.': 'Дар барнома иштирок намекунед? Аз қайд гузаред.',
		'Check if the input is correct': 'Дурустии воридкуниро тафтиш кунед',
		other: 'Дигар',
		organizationName: 'Номгӯи ташкилот',
		personnelNumber: 'Рақами Табелӣ',
		'A subsidized fare requires all passengers on the booking to have benefits.':
			'Истифодабарии тарофаи субсидияшуда имконпазир аст, агар ҳамаи мусофирон дар фармоиш ҳуқуқ ба имтиёзро дошта бошанд',
		'I have a loyalty card': 'Ман корти садоқат дорам',
		'Don\'t have a card yet?': 'Дар барнома иштирок намекунед?',
		'Register now': 'Аз қайд гузаред',
		Male: 'Мард',
		Female: 'Зан',
		Cancel: 'Бекор кардан',
		Confirm: 'Тасдиқ кардан',
		'Please, check passenger data': 'Маълумотҳои мусофирро тафтиш кунед',
		promoCode: 'Промокод',
		'Passenger with disabilities': 'Мусофир бо имконияти маҳдуд',
		'Passengers with disabilities and other persons with reduced mobility and persons accompanying them shall board the aircraft before boarding':
			'Мусофирон бо имконияти маҳдуд ва шахсони дигар бо ҳаракати маҳдуд, инчунин шахсони онҳоро ҳамроҳикунанда, бояд ба бори ҳавопаймо пеш аз саворкунӣ бароянд',
		'Booking details of the accompanying passenger': 'Маълумотҳои бандкунии мусофири ҳамроҳикунанда',
		'Fill in the fields with the booking details of the accompanying passenger over 18 years of age. Please note that the flight dates, flight and class of service for both passengers must be the same.':
			'Сатрҳо бо маълумотҳои бандкунии мусофири ҳамроҳикунандаи синнаш аз 18 сола калонро пур кунед. Ба он диққат диҳед ,ки санаҳои парвоз, самти парвоз ва дараҷаи хизматрасонии ҳар ду мусофирон бояд якхела бошанд.',
		'I confirm that the provided ticket number and the name of the accompanying passenger are correct and valid.':
			'Тасдиқ мекунам, ки рақами пешкашгардидаи чиптаи ҳавопаймоӣ ва ному насаби мусофири ҳамроҳикунанда дуруст навишта шудаанд ва эътибор доранд.',
		accompanyingPersonName: 'Ному насаби мусофири ҳамроҳикунанда',
		accompanyingPersonTicketNumber: 'Рақами чиптаи ҳавопаймо',
		'13 digits': '13 рақамро ворид кунед',
		'Select at least one service from the list below': 'Хизматрасониҳоро аз рӯихат интихоб кунед',
		'Replacement of passport based on age or change of surname upon marriage or divorce':
			'Ивазкунии шиноснома аз рӯи синну сол ё ки тағйир ёфтани насаб ҳангоми бастан ё ки бекор кардани ақди никоҳ',
		'Attach supporting document': 'Замима кардани ҳуҷҷати тасдиқкунанда лозим мешавад',
		'Attach a photocopy of the certificate': 'Нусхаи сурати шаҳодатномаро замима кунед',
		'File format: jpg, pdf. File size: no more than 5MB': 'Шакли файл: jpg, pdf. Андозаи файл: на бештар аз 5 МБ',
		Show: 'Нишон додан',
		linkedTraveller: 'Ҳамроҳикунанда',
		'Exceeded the number of editable characters': 'Миқдори аломатҳои тағйирёбанда аз зад гузаштааст',
		'Attach files': 'Файлҳоро замима кунед',
		'It is forbidden to change the first letter': 'Тағйир додани ҳарфи якум манъ аст',
		'It is forbidden to change several types of passenger data':
			'Тағйир додани якчанд намудҳои маълумотҳои мусофирон манъ аст',
		'Popular countries': 'Кишварҳои машҳур',
		'Other countries': 'Ҳамаи кишварҳо'
	},
	PassengerTypes: {
		Adult: 'Калонсол',
		Adult_0: 'Калонсол',
		Adult_1: 'Калонсолон',
		Adult_2: 'Калонсолон',
		ADT: 'Калонсол',
		ADT_0: 'Калонсол',
		ADT_1: 'Калонсолон',
		ADT_2: 'Калонсолон',
		AAT: 'Калонсол',
		AAT_0: 'Калонсол',
		AAT_1: 'Калонсолон',
		AAT_2: 'Калонсолон',
		Child: 'Кӯдак',
		Child_0: 'Кӯдак',
		Child_1: 'Кӯдак',
		Child_2: 'Кӯдакон',
		CLD: 'Кӯдак',
		CLD_0: 'Кӯдак',
		CLD_1: 'Кӯдак',
		CLD_2: 'Кӯдакон',
		CNN: 'Кӯдак',
		CNN_0: 'Кӯдак',
		CNN_1: 'Кӯдак',
		CNN_2: 'Кӯдакон',
		CTN: 'Кӯдак',
		CTN_0: 'Кӯдак',
		CTN_1: 'Кӯдак',
		CTN_2: 'Кӯдакон',
		CHD: 'Кӯдак',
		CHD_0: 'Кӯдак',
		CHD_1: 'Кӯдак',
		CHD_2: 'Кӯдакон',
		Infant: 'Навзод',
		Infant_0: 'Навзод',
		Infant_1: 'Навзод',
		Infant_2: 'Навзодон',
		INF: 'Навзод',
		INF_0: 'Навзод',
		INF_1: 'Навзод',
		INF_2: 'Навзодон',
		'Infant with seat': 'Навзод бо ҷой',
		'Infant with seat_0': 'Навзод бо ҷой',
		'Infant with seat_1': 'Тифлҳо бо ҷой',
		'Infant with seat_2': 'Тифлҳо бо ҷой',
		INS: 'Навзод бо ҷой',
		INS_0: 'Навзод бо ҷой',
		INS_1: 'Тифлҳо бо ҷой',
		INS_2: 'Тифлҳо бо ҷой',
		YTH: 'Ҷавонон',
		YTH_0: 'Ҷавонон',
		YTH_1: 'Ҷавонон',
		YTH_2: 'Ҷавонон',
		SCF: 'Нафақахӯр (зан)',
		SCF_0: 'Нафақахӯр (зан)',
		SCF_1: 'Нафақахӯрон (зан)',
		SCF_2: 'Нафақахӯрон (зан)',
		SCM: 'Нафақахӯр (мард)',
		SCM_0: 'Нафақахӯр (мард)',
		SCM_1: 'Нафақахӯрон (мард)',
		SCM_2: 'Нафақахӯрон (мард)',
		РВТ: 'Навзод бо ҷой',
		РВТ_0: 'Навзод бо ҷой',
		РВТ_1: 'Тифлҳо бо ҷой',
		РВТ_2: 'Тифлҳо бо ҷой',
		SRC: 'Нафақахӯр',
		SRC_0: 'Нафақахӯр',
		SRC_1: 'Нафақахӯрон',
		SRC_2: 'Нафақахӯрон'
	},
	Passengers: {
		Adults: 'Калонсолон',
		Teenagers: 'Наврасон',
		Children: 'Кӯдакон',
		'Latin symbols and digits': 'Ҳарфҳои лотинӣ ва ҳарфҳо',
		Infants: 'Тифлҳо',
		'Infants with seat': 'Тифлҳо бо ҷой',
		'Young adult': 'Ҷавонон',
		'Senior (men)': 'Нафақахӯрон (мард)',
		'Senior (female)': 'Нафақахӯрон (зан)',
		'12-23 years': '12-23 сола',
		'12-18 years': '12-18 сола',
		'55+ years': '55+ сола',
		'60+ years': '60+ сола',
		'12+ years': '12+ сола',
		'2-11 years': '2-11 сола',
		'Up to 2 years': 'То 2 сола',
		'Add other categories': 'Тоифаҳои дигар',
		'Adults over twelve years old': 'Болиғони аз дувоздаҳсола калон',
		'Young peoples from twelve to eighteen years old': 'Ҷавонони аз 12 то 18 сола',
		'Children from two to eleven years old': 'Кӯдакон аз ду то ёздаҳсола',
		'Infants up to two years old, without seat': 'Тифлҳои то дусола, бе ҷой',
		'Infants up to two years old, with seat': 'Тифлҳои то дусола, бо ҷой',
		'Young peoples 12-23 years old': 'Ҷавонон аз дувоздаҳсола то бисту се сола',
		'Young peoples 12-18 years old': 'Ҷавонони аз 12 то 18 сола',
		'Senior men up 60 years': 'Мардон дар синни аз 60 сола',
		'Senior women up 55 years': 'Занон дар синни аз 55 сола',
		'Please notice, you must receive your boarding passes at the airport':
			'Диққат диҳед, ки талонҳои саворшавиро танҳо дар фурудгоҳ гирифта метавонед',
		'Senior men up 60 years, Senior women up 55 years': 'Нафақахӯрон мардон аз 60 сола, занон аз 55 сола',
		Senior: 'Нафақахӯрон',
		'men 60+ female 55+': 'М 60+ З 55+'
	},
	PaymentErrors: {
		'An error occurred while executing the request': 'Ҳангоми иҷрокунии дархост хатогӣ рух дод',
		'Please try again later or contact a customer support service':
			'Такроран кӯшиш кунед ё ки бо хадамоти дастгирии мизоҷон тамос гиред.',
		Error: 'Хато',
		OK: 'OK',
		Sirena2_already_processed: 'Фармоиш аллакай пардохта шудааст',
		Sirena2_access_denied:
			'Ба системаи пардохт пайваст карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ access_denied-ро хабар диҳед.',
		Sirena2_system_error: 'Ба системаи пардохт пайваст карда нашуд. Саҳифаро нав кунед.',
		Sirena2_fatal_error: 'Ба системаи пардохт пайваст карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед.',
		Sirena2_order_error:
			'Фармоишро коркард карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ order_error-ро хабар диҳед.',
		Sirena2_invalid_order:
			'Фармоишро ёфта нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ invalid_order-ро хабар диҳед.',
		Sirena2_pricing_error:
			'Фармоишро коркард карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ pricing_error-ро хабар диҳед.',
		Sirena2_booking_error:
			'Фармоишро коркард карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ booking_error-ро хабар диҳед.',
		Sirena2_wrong_amount: 'Арзиши носаҳеҳи фармоиш. Саҳифаро нав кунед ё ки ба хадамоти дастгирӣ муроҷиат кунед.',
		Sirena2_session_error: 'Ҷараёни пардохтро оғоз карда нашуд. Саҳифаро нав кунед.',
		Sirena2_max_attempts: 'Кӯшишҳои пардохтани фармоиш ба анҷом расиданд.',
		Sirena2_repeat_needed: 'Ба пардохт гузашта нашуд. Саҳифаро нав кунед.',
		Sirena2_unknown_tax_source:
			'Фармоишро коркард карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ unknown_tax_source-ро хабар диҳед.',
		Sirena2_invalid_tax_data:
			'Фармоишро коркард карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ invalid_tax_data-ро хабар диҳед.',
		Sirena2_ambiguous_taxation_system:
			'Фармоишро коркард карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ ambiguous_taxation_system-ро хабар диҳед.',
		Sirena2_unknown_taxation_system:
			'Фармоишро коркард карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ unknown_taxation_system-ро хабар диҳед.',
		Sirena2_no_taxation_system:
			'Фармоишро коркард карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ no_taxation_system-ро хабар диҳед.',
		Sirena2_shop_commission:
			'Фармоишро коркард карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ shop_commission-ро хабар диҳед.',
		Sirena2_shop_status: 'Фармоиш аллакай пардохт шудааст ё ки бекор гардидааст',
		Sirena2_shop_common:
			'Ба системаи пардохтан пайваст карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ shop_common-ро хабар диҳед.',
		Sirena2_shop_session:
			'Ба системаи пардохтан пайваст карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ shop_session-ро хабар диҳед.',
		Sirena2_bank_network:
			'Бонк муваққатан дастнорас аст. Саҳифаро нав кунед ва боз як маротибаи дигар кӯшиш намоед. Агар муаммо нигоҳ дошта шавад, ба хадамоти дастгирӣ муроҷиат кунед.',
		Sirena2_bank_account:
			'Реквизитҳои нодурусти корт. Реквитиҳоро тафтиш карда, боз як маротибаи дигар кӯшиш намоед.',
		'Sirena2_bank_i-prohibition':
			'Бо ин корт пардохт карда намешавад. Ба бонк муроҷиат кунед ё ки аз корти дигар истифода баред.',
		Sirena2_system_3dsecure:
			'Реквизитҳои кортро шинохта нашуд. Маълумотҳои воридкардашударо тафтиш кунед ва боз як маротиба кӯшиш кунед.',
		Sirena2_system_common:
			'Ба системаи пардохтан пайваст карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ system_common-ро хабар диҳед.',
		Sirena2_3dsecure_failed:
			'Реквизитҳои кортро шинохта нашуд. Маълумотҳои воридкардашударо тафтиш кунед ва боз як маротиба кӯшиш кунед.',
		Sirena2_user_timeout: 'Вақти барои пардохт гузашт. Саҳифаро нав кунед ва боз як маротибаи дигар кӯшиш намоед.',
		Sirena2_user_cancel: 'Амалиёт бекор карда шуд.',
		Sirena2_user_duplicate:
			'Пардохтро коркард карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ ошибки user_duplicate-ро хабар диҳед.',
		Sirena2_shop_network:
			'Ба системаи пардохтан пайваст карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ shop_network-ро хабар диҳед.',
		Sirena2_shop_price:
			'Ҷараёни пардохтро оғоз карда нашуд. Ба хадамоти дастгирӣ муроҷиат кунед ва коди хатогӣ shop_price-ро хабар диҳед.',
		Sirena2_shop_invalid_fop: 'Ин усули пардохт дастнорас аст. Усули дигарро истифода баред.',
		Sirena2_shop_wrong_amount:
			'Арзиши носаҳеҳи фармоиш. Саҳифаро нав кунед ё ки ба хадамоти дастгирӣ муроҷиат кунед.',
		Sirena2_bank_funds:
			'Дар суратҳисоб маблағ кифоя нест. Тавозунро пурра кунед ё ки аз корти дигар истифода баред.',
		Sirena2_bank_limit:
			'Лимити амалиётҳо аз рӯи корт аз ҳад гузаштааст. Ба бонк муроҷиат кунед ё ки аз корти дигар истифода баред.',
		Sirena2_bank_common:
			'Бонк пардохтро рад кард. Боз як мароиба кӯшиш кунед ё ки аз корти дигар истифода баред. Агар муаммо нигоҳ дошта шавад, ба хадамоти дастгирӣ муроҷиат кунед.',
		Sirena2_system_in_progress:
			'Пардохт дар коркард. Ҳолати фармоишро баъд аз якчанд дақиқа тафтиш кунед. Агар муаммо нигоҳ дошта шавад, ба хадамоти дастгирӣ муроҷиат кунед.',
		Sirena2_system_fraud: 'Муҳофиза аз амалиётҳои шубҳанок ба кор даромад.'
	},
	PaymentForm: {
		Title_MoneyCarePro: 'Ба қарз харидан',
		Header_MoneyCarePro: 'Ба қарз харидан',
		Title_PayLate: 'Ба насия',
		Header_PayLate: 'Ба насия',
		Title_Idram: 'Тавассути Idram пардохт кардан',
		Header_Idram: 'Тавассути Idram пардохт кардан',
		Payment: 'Пардохт',
		Total: 'Ҳамагӣ',
		'Choose a convenient payment method': 'Усули қулайи пардохтро интихоб кунед',
		'Credit or debit card': 'Бо карта онлайн',
		Service: 'Чиптаҳо ва хизматрасониҳо',
		Charge: 'Боҷҳо ва комиссияҳо',
		'Pay by credit or debit card': 'Пардохти онлайн бо корт',
		'Other methods': 'Усулҳои дигари пардохт',
		'In the next step you will be taken to a Google Pay page.':
			'Дар қадами оянда, шумо ба саҳифаи пардохти Google Pay равона карда мешавед.',
		'Test payment': 'Пардохти санҷишӣ',
		'Edit order': 'Тағйир додани фармоиш',
		Instalment: 'Ба насия',
		Aeroexpress: 'Аэроэкспресс',
		Airticket: 'Чиптаҳо',
		Baggage: 'Бағоҷ',
		Insurance: 'Суғуртакунӣ',
		BusinessLounge: 'Бизнес-зал',
		Businesslounge: 'Бизнес-зал',
		Vip: 'VIP - хизматрасониҳо',
		Meals: 'Ғизо',
		'Please, click «Edit Order» after successful payment in Kaspi.kz APP to open your order.':
			'Баъд аз пардохти бомуваффақ дар барномаи Kaspi.kz, бо пахш кардани тугмаи «тағйир додани фармоиш», ба фармоиш баргардед.',
		Seats: 'Ҷойҳо',
		'Failed to get billing code': 'Коди пардохтро гирифта нашуд',
		Invoicebox: 'Инвойсбокс',
		FPS: 'Системаи пардохтҳои зуд',
		SberPay: 'SberPay',
		'Payment code': 'Коди пардохт',
		Pay: 'Пардохт кардан',
		'Problems with payment?': 'Муаммоҳо бо пардохт?',
		'Payment by QIWI': 'Тавассути QIWI пардох кардан',
		'Payment problems hint':
			'Агар равзана барои воридкунии маълумотҳои корти шумо пайдо нашавад, барои аз нав кушодани саҳифа кӯшиш кунед.',
		'Please, click «Edit Order» after successful payment in QIWI app to open your order.':
			'Баъд аз пардохти бомуваффақ дар барномаи QIWI, бо пахш кардани тугмаи «тағйир додани фармоиш», ба фармоиш баргардед.',
		'Payment by this method is temporarily unavailable, please try refreshing the page or try again later.':
			'Пардохт бо ин усул муваққатан имконнопазир аст, саҳифаро нав кунед ё ки кӯшишро дертар такрор кунед.',
		'The payment with this method is unavailable.': 'Пардохт бо ин усул дастнорас аст.'
	},
	PaymentProvider: {
		PayLate: 'PayLate',
		MoneyCarePro: 'MoneyCarePro'
	},
	PaymentResult: {
		'Payment successfully complete': 'Пардохт бомуваффақият ба анҷом расид',
		'View booking': 'Гузариш ба фармоиш',
		'Payment has failed': 'Пардохт амалӣ нашуд',
		'Try again': 'Боз кӯшиш кардан'
	},
	PaymentTimeLimit: {
		'Booking must be completed': 'Фармоиш бояд ба расмият дароварда шавад',
		'Booking must be paid': 'Фармоиш бояд пардохта шавад',
		before: 'то',
		'today before': 'имрӯз то',
		'Sorry,': 'Мутаассифона,',
		'time to complete booking has expired': 'вақти барасмиятдарории фармоиш гузашт',
		'Repeat search': 'Такрор кардани ҷустуҷӯ',
		'Cancel order': 'Бекор кардани фармоиш'
	},
	PriceGraph: {
		'Outbound flight': 'Самти парвоз ба он ҷоро интихоб кунед',
		'Return flight': 'Самти парвози бозгаштро интихоб кунед',
		min: 'дақ',
		max: 'макс.',
		'Select month': 'Моҳро интихоб кунед',
		Select: 'Итихоб кардан',
		from: 'аз',
		'Approximate prices for 1 person for 1 direction': 'Нархҳои тахминӣ ба 1 нафар ба 1 тараф нишон дода шудаанд',
		'Price for 1 direction': 'Нархҳо ба як тараф',
		'Show flights': 'Нишон додани самтҳои парвоз'
	},
	PriceInMiles: {
		miles_1: 'миля',
		miles_2: 'миля',
		miles_3: 'миляҳо'
	},
	PriceLock: {
		'Lock this price! We will wait for you': 'Нархҳоро ях кунонед! Мо интизор мешавем',
		'Lock it for 72 hours from just': 'Яхкунонии нархҳо ба 72 соат ҳамагӣ ба',
		'per passenger and leg': 'ба мусофир',
		'I want to lock the price for this flight': 'Нархҳо ба ин парвозро ях кунонидан мехоҳам'
	},
	PromoCode: {
		'Promo code not applied': 'Промокод татбиқ нашуд',
		reset: 'нест кардан',
		'Do you have a promo code?': 'Промокод доред?',
		'Promo code applied': 'Промокод татбиқ шуд',
		'Enter a promo code': 'Промокодро ворид кунед',
		'Promo code not applied for this flights': 'Промокод барои ин парвоз татбиқ нашуд',
		'Promo code': 'Промокод',
		Required: 'Сатри ҳатмӣ',
		'I confirm that I am an employee of Rostech. Otherwise, the Carrier has the right to cancel the ticket.':
			'Тасдиқ мекунам, ки корманди Ростех мебошам. Дар ҳолати баръакс Кашонанда ҳуқуқи бекор кардани чиптаро дорад.',
		'The number of characters must not exceed {{number}}': 'Миқдори аломатҳо набояд аз {{number}} бештар бошад'
	},
	PromoLoader: {
		'One moment please': 'Лутфан, як сония',
		'Discover new horizons': 'Уфқҳои навро кушоед',
		'International flights from Kazakhstan': 'Самтҳои нави парвоз аз Қазоқистон',
		Istanbul: 'Истамбул',
		Tbilisi: 'Тбилиси',
		Moscow: 'Москва',
		Xiang: 'Хубэй',
		'Comfort on board': 'Ҳаловат дар борт',
		Meal: 'Ғизо',
		'Wi-Fi Connect': 'Интернет дар борт',
		Fleet: 'Флоти мо',
		Seats: 'Ҷойҳо',
		'It is safe to fly': 'Паридан бехавф',
		'2,000 miles giveaway!': '2 000 миля туҳфа мекунем!',
		'Choose your seats when booking': 'Ҷойҳоро ҳангоми бандкунӣ интихоб кунед',
		'Save up to 25% when buying extra baggage right away':
			'Ҳангоми бандкунӣ бо харидани бағоҷи иловагӣ то 25% сарфа кунед',
		'We want to make sure your travel experience is as fun and smooth as possible also when travelling as a family. All the way from planning your trip to arriving at the airport and enjoying your time in the air, we pay special attention to your comfort.':
			'Мехоҳем, ки сафари шумо ҳар чӣ бештар сабук ва форам гузарад, хусусан, агар бо тамоми оила сафар карда истода бошед. Мо ҳамеша ба ҳаловати шумо диққати махсус медиҳем — аз лаҳзаи ба нақша гирифтани саёҳати шумо то расидан ба фурудгоҳ ва дар худи ҳавопаймо.',
		'Every Nordwind flight is an opportunity to relax and replenish. On our local flights by Russia and flights to CIS, we serve a diverse selection of food, snacks and beverages, tailored to the time and length of your flight.':
			'Бо самтҳои парвози Nordwind Airlines саёҳат карда, ратсиони идеалии ғизоро бо интихоби хӯриш, салат ва таъоми гарм аз намудҳои пешкашгардида ташаккул дода метавонед.',
		'The Nordwind fleet consists of over 30 aircraft. Our fleet is one the most modern in country, and thanks to it can offer you even better travel comfort on our flights.':
			'Парки Nordwind без аз 30 ҳавопаймоҳо иборат аст. Парки мо муосиртарин дар кишвар мебошад ва бо шарофати ин мо ба шумо боз ҳаловати бештарро пешниҳод карда метавонем.',
		'Every flight is an opportunity to relax and replenish. On our local flights by Russia and flights to CIS, we serve a diverse selection of food, snacks and beverages, tailored to the time and length of your flight.':
			'Бо мо саёҳат карда, ратсиони идеалии ғизоро бо интихоби хӯриш, салат ва таъоми гарм аз намудҳои пешкашгардида ташаккул дода метавонед.',
		'The fleet consists of over 30 aircraft. Our fleet is one the most modern in country, and thanks to it can offer you even better travel comfort on our flights.':
			'Парки мо без аз 30 ҳавопаймоҳо иборат аст. Он муосиртарин дар кишвар мебошад ва бо шарофати ин мо ба шумо боз ҳаловати бештарро пешниҳод карда метавонем.',
		'Flying is not a reason to refuse to communicate with family and colleagues. Wi-Fi internet on board is a unique portal to the world of entertainment and information in flight.':
			'Сафар - ин сабаби рад кардани муошират бо оила ва ҳамкорон нест. Интернети беноқил дар борти ҳавопаймои мо ин портали беҳамто ба олами дилхушиҳо ва иттилоот дар парвоз аст.',
		'Want to sit together or love the window seat? Do not leave the choice of place to chance.':
			'Ҳамҷоя ё ки дар назди тиреза нишастан мехоҳед? Интихоби ҷойро ба тасодуф нагузоред.',
		'From locking middle seats to completely disinfecting our aircraft, we do our best to keep you safe.':
			'Аз мамнӯъкунии курсиҳои миёна ва талаб кардани истифодаи ниқобҳои муҳофизатӣ, то безараргардонии ҳар як кунҷ дар ҳавопаймоҳои мо - тамоми кӯшишро ба харҷ медиҳем, то ки шумо дар амният ва саломат бошед.',
		'To thank you for your loyalty and support, we grant our club members 2,000 miles!':
			'Барои ташаккур гуфтан барои садоқат ва дастгирӣ, мо ба иштирокчиёни маҳфили мо 2000 миля тақдим мекунем!',
		'Don’t let chance affect your comfort and convenience.': 'Ҳаловат ва қулайии худро ба тасодуф нагузоред.'
	},
	PromoMessage: {
		'Buy now - pay later': 'Парвоз ҳозир - пардохт баъд! КЕШБЕК 15%',
		'Learn more': 'Бештар донистан',
		'You can buy any ticket with credit for 12 months, without an initial payment, with a grace period of 30 days.':
			'Усули қулайи бандкунии нархи чипта. Чиптаҳо дар почтаи Шумо дарҳол баъд аз ба расмият даровардан. Пардохти пешакӣ 0 рубл.',
		'Only Citizens of the Republic of Uzbekistan and Tajikistan are allowed on the flight':
			'Ба самти парвоз танҳо шаҳрвандони Ҷумҳуриҳои Ӯзбекистон ва Тоҷикистон роҳ дода мешаванд'
	},
	QuickSearchForm: {
		'Modify search': 'Тағйир додани ҷустуҷӯ',
		Adult_0: 'Калонсол',
		Adult_1: 'Калонсолон',
		Adult_2: 'Калонсолон',
		Child_0: 'Кӯдак',
		Child_1: 'Кӯдак',
		Child_2: 'Кӯдакон',
		Infant_0: 'Навзод',
		Infant_1: 'Навзод',
		Infant_3: 'Навзодон',
		ADT_0: 'калонсол',
		ADT_1: 'калонсолон',
		ADT_2: 'калонсолон',
		passenger_0: 'мусофир',
		passenger_1: 'мусофирон',
		passenger_2: 'мусофирон',
		МЛА_0: 'Мусофир (ҷавнонон)',
		МЛА_1: 'Мусофир (ҷавнонон)',
		МЛА_2: 'Мусофирон (ҷавонон)',
		SCM_0: 'Мусофир (нафақахӯрон)',
		SCM_1: 'Мусофир (нафақахӯрон)',
		SCM_2: 'Мусофирон (нафақахӯрон)',
		SCF_0: 'Мусофир (нафақахӯрон)',
		SCF_1: 'Мусофир (нафақахӯрон)',
		SCF_2: 'Мусофирон (нафақахӯрон)',
		PDA_0: 'Наврас',
		PDA_1: 'Наврас',
		PDA_2: 'Наврасон',
		YTH_0: 'Ҷавонон',
		YTH_1: 'Ҷавонон',
		YTH_2: 'Ҷавонон',
		SRC_0: 'Нафақахӯр',
		SRC_1: 'Нафақахӯрон',
		SRC_2: 'Нафақахӯрон',
		РВТ_0: 'Навзод бо ҷой'
	},
	RecaptchaPage: {
		'You\'re not a bot, are you?': 'Мабодо бот набошед?'
	},
	RecommendedBadge: {
		'Best choice': 'Интихоби беҳтарин'
	},
	Refund: {
		'I agree with the': 'Розиям бо',
		'Terms of Service': 'қоидаҳои пешкашкунии хидмат',
		And: 'ва',
		'Privacy Policy': 'сиёсати махфият',
		New: 'Дархости нав',
		AllDataSaved: 'Маълумотҳо маҳфуз карда шуданд',
		Adopted: 'Дархост қабул гардид',
		Calculated: 'Маблағи баргардонидан ҳисоб карда шуд',
		ClaimReceived: 'Дархост фиристода шуд',
		AwaitingPayment: 'Баргардонидани маблағ дар интизорӣ',
		TimelimitExpired: 'Вақти тасдиқкунӣ гузашт',
		Finished: 'Ба анҷом расид',
		Cancelled: 'Бекор карда шуд',
		Rejected: 'Рад карда шуд',
		NeedConfirm: 'Тасдиқро интизор аст',
		InProcess: 'Дар ҷараён',
		'Add new request': 'Офаридани дархости нав',
		Refused: 'Аз ҷониби истифодабаранда рад карда шуд',
		FlightCancellationOrDelay: 'Бекоркунӣ ё ки таъхири самти парвози дар чипта нишондодашуда;',
		Rerouting: 'Тағйирдиҳии хатсайр (бе назардошти шароити номусоиди обу ҳаво ва форс-мажорҳо);',
		FlightOperationOutOfSchedule: 'Иҷроиши парвозҳо берун аз нақша;',
		SeatUnavailability: 'Набудани ҷойҳо барои мусофирон ба самти парвоз ва санаи дар чипта нишондодашуда;',
		EnduringSecurityScreening:
			'Агар мусофир ба борти ҳавопаймо аз сабаби муоинаи дурудароз / муоина, бо шарте, ки дар вақти чунин муоина ягон моддаҳои манъкардашуда ё ки ашёҳо муайян карда нашаванд;',
		FailedEnsureConnectionOfFlights:
			'Агар кашонанда ҳамҷоякунинии самтҳои парвозро таъмин накунад, бо шарте, ки самтҳои парвози ҳамҷояшуда якмаротибагӣ мебошанд;',
		Illness:
			'Бемории мусофир, аъзои оилаи ӯ, ки ҳамҷоя бо мусофир парвоз мекунад, агар чунин беморӣ бо ҳуҷҷатҳои мутобиқи тиббӣ тасдиқ гардида бошад, ё ки дар ҳолати марги мусофир ё ки аъзои оилаи ӯ, агар марг бо ҳуҷҷатҳои мутобиқи тиббӣ тасдиқ карда шуда бошад, бо шарти он, ки оиди ин то анҷоми вақти бақайдгирии дар чипта нишон дода шавад; Иттилооти бештар дар бораи талабот ба чунин ҳуҷҷатҳои тиббӣ дар ин ҷо баён карда шудааст;',
		FailedToProvideServices:
			'Агар кашонанда ба мусофир хизматрасониҳоро мутобиқи дараҷаи дар чипта нишондодашуда пешкаш накунад;',
		FailedToIssueTicketAppropriately:
			'Агар кашонанда ё ки агенти ваколатдори ӯ чиптаро ба таври бояду шояд навишта надиҳанд;',
		OtherCases: 'Дар ҳолатҳои дигар, вақте ки мусофир бо кашонидан бо айби кашонанда таъмин карда нашавад;',
		MedicalCertificate: 'Маълумотномаи тиббӣ',
		Request: 'Дархост',
		'Request #{{requestId}}': 'Дархост #{{requestId}}',
		Create: 'Офарида шуд',
		'Your comments': 'Шарҳҳои шумо',
		'Refund amount': 'Ба баргардонидан',
		'Ticket price': 'Арзиши фармоиш',
		'FareExchange penalty': 'Ҷарима барои мубодила',
		Continue: 'Давом додан',
		Back: 'Ба қафо',
		'Select passengers': 'Мусофиронро интихоб кунед',
		'Choose the reason for refund': 'Сабаби баргардониданро интихоб кунед',
		'Involuntary refund': 'Баргардонидани маҷбурӣ',
		'Voluntary refund': 'Баргардонидани ихтиёрӣ',
		'my plans have changed': 'нақшаҳои ман тағйир ёфтанд',
		'Attach the required files': 'Файлҳои лозимиро замима кунед',
		'File format: jpg, pdf. File size: no more than 5MB':
			'Шакли файл: jpg, png, pdf, doc, docx. Андозаи файл: на бештар аз 5МБ',
		'Your name': 'Номи шумо',
		'Your email': 'Email-и шумо',
		'Your phone': 'Телефони шумо',
		'I agree to the': 'Розиям бо',
		'Terms of Service and Privacy Policy': 'Қоидаҳои пешкашкунии хидмат ва сиёсати махфият',
		'Create request': 'Офаридани дархост',
		'Only letters': 'Танҳо ҳарфҳо',
		Required: 'Сатри ҳатмӣ',
		'Wrong email': 'Email-и нодуруст',
		'Wrong phone': 'Рақами нодурусти телефон',
		For: 'барои',
		Files: 'Файлҳо',
		'Refund ticket': 'Баргардонидани чипта',
		'Refund restrictions': 'Маҳдудиятҳо ҳангоми баргардонидан',
		Note: 'Диққат диҳед',
		'The possibility and amount of refund will be calculated by the operator after sending the application. The answer will be sent to your E-mail and is also available on the order page.':
			'Имконият ва маблағи баргардонидан аз ҷониби оператор баъд аз фиристодани дархост ҳисоб карда мешаванд. Ҷавоб ба почтаи электронии шумо фиристода мешавад, инчунин дар саҳифаи фармоиш дастрас мегардад.',
		'After submitting the request, the seats you have selected will be canceled.':
			'Баъд аз фиристодани дархост ҷойҳои интихобкардаи шумо бекор карда мешаванд.',
		'The money will be returned to the card used to pay for the ticket within 15 days':
			'Маблағ ба корти ҳангоми пардохти чипта истифодашуда, дар давоми 15 рӯз баргардонида мешавад.',
		Reject: 'Бекор кардан',
		Confirm: 'Тасдиқ кардан',
		'The request is accepted for processing. The answer will be sent to your email and also available on the order page.':
			'Дархости шумо қабул гардид ва коркард карда мешавад. Ҷавоб ба email фиристода мешавад, инчунин дар саҳифаи фармоиш дастрас мегардад.',
		'The request was deleted. Want to create a new request?':
			'Дархост нест карда мешавад. Дархости нав офаридан мехоҳед?',
		'Successful refund. Confirmation and detalization have been sent to your e-mail':
			'Баргардонидани бомуваффақ. Детализатсия ба e-mail-и шумо фиристода мешавад',
		Ok: 'Ok',
		Yes: 'Ҳа',
		No: 'Не',
		'Request for refund': 'Дархост барои баргардонидан',
		'Successfully refund': 'Баргардонидани бомуваффақ',
		'Delete request': 'Нест кардани дархост',
		FlightNumberChange: 'Тағйирёбии рақами самти парвоз',
		FlightRetimed: 'Самти парвоз барқарор карда шуд',
		FlightCancelled: 'Самти парвоз бекор карда шуд',
		PermanentWithdrawalOfService: 'Қатъшавии доимии хизматрасонӣ',
		LaborDispute: 'Баҳси меҳнатӣ',
		Bereavement: 'Гумкунии вазнин',
		UnableToObtainNecessaryDocumentation: 'Ҳуҷҷатҳои лозимиро гирифтан имконнопазир аст',
		Strike: 'Корпартоӣ',
		Weather: 'Шароити ҳаво',
		NaturalDisaster: 'Офати табиӣ',
		UnacceptableReaccommodation: 'Ҷойгиркунии ғайри қобили қабул',
		Refund_Passengers: 'Давом додан',
		Refund_Reason: 'Давом додан',
		Refund_CreateTicket: 'Давом додан',
		'terms of tariff': 'шартҳои тарофа',
		'Back to order': 'Ба фармоиш баргаштан',
		'To make an exchange please contact a customer support service':
			'Барои гузаронидани баргардонидан ба Хадамоти дастгирӣ муроҷиат кардан лозим аст',
		'Oops...': 'Упс...',
		'View related booking': 'Кушодани фармоиши пайвастгардида',
		'It is not possible to refund a ticket that has been checked-in for a flight':
			'Баргардонидани чипта, ки аз рӯи он бақайдгирӣ ба самти парвоз имконнопазир аст',
		'If you wish to make a refund, please cancel your flight check-in.':
			'Агар баргардониданро амалӣ кардан хоҳед, пешакӣ бақайдгирӣ ба самти парвозро бекор кунед.',
		'You can do it yourself by going to <a href=\'{{link}}\' target=\'_blank\'>Online Registration section</a>.':
			'Инро ба қисмати <a href=\'{{link}}\' target=\'_blank\'>Бақайдгирии онлайнӣ</a> гузашта мустақилона кардан мумкин аст.',
		'It is not possible to refund a used ticket': 'Баргардонидани чиптаи истифодашуда имконнопазир аст',
		'The ticket has been flown on, you cannot return a used ticket.':
			'Бо чипта парвоз амалӣ карда шудааст, чиптаи истифодашударо баргардонида наметавонед.'
	},
	RegisteredPassenger: {
		Economy: 'Эконом',
		Business: 'Бизнес',
		First: 'Якум',
		'Download boarding pass': 'Боргирӣ кардани талони саворшавӣ',
		Download: 'Боргирӣ кардан',
		CarryOn: 'Бори дастӣ',
		CheckedBaggage: 'Бағоҷ',
		SportingEquipment: 'Лавозимоти варзишӣ',
		'Select flight for download': 'Парвозро интихоб кунед',
		'Select flight': 'Парвозро интихоб кунед',
		Seats: 'Ҷойҳо',
		Meal: 'Ғизо',
		'Cancel check-in': 'Бекор кардани бақайдгирӣ',
		'Retry check-in': 'Такрор кардани бақайдгирӣ',
		Yes: 'Ҳа',
		No: 'Не',
		'You are going to cancel online check-in for passenger {{passenger}}. Are you sure about this?':
			'Боварӣ доред ,ки бақайдгирии онлайниро барио мусофир {{passenger}} бекор кардан мехоҳед?',
		'Send to email': 'Ба почтаи электронӣ фиристодан',
		Send: 'Фиристодан',
		'Registration available only at airport': 'Бақайдгирӣ танҳо дар фурудгоҳ дастрас аст',
		'You must receive the boarding pass at the airport on the registration desk.':
			'Талони саворшавиро дар фурудгоҳ дар пояи бақайдгирӣ гирифтан лозим аст.',
		'Send all documents to email': 'Фиристодани ҳамаи ҳуҷҷатҳо ба почта',
		Cancel: 'Бекор кардан',
		'Required field': 'Сатри ҳатмӣ',
		'Please enter a valid email': 'ЛУтфан, суроғаи амалкунандаи почтаи электрониро ворид кунед',
		Passenger: 'Мусофир',
		Seat: 'Ҷой',
		'Boarding pass': 'Талони саворшавӣ',
		Email: 'Суроғаи почтаи эл.',
		'Please notice that online check-in will also be cancelled for the following passengers':
			'Бақайдгирӣ инчунин барои мусофирони зерин бекор карда мешавад:',
		'Select segments to cancel': 'Барои бекоркунӣ парвозҳоро интихоб кунед'
	},
	ResendTicketsForm: {
		Email: 'Суроғаи почтаи эл.',
		Send: 'Фиристодан',
		Required: 'Пур кардан лозим аст',
		'Resend booking': 'Фиристодани чиптаҳо',
		'Failed to send tickets to the specified mail, try again later':
			'Чиптаҳоро ба почтаи нишондодашуда фиристода нашуд, такроран кӯшиш кунед',
		'Please enter a valid email': 'Суроғаи иловакардашудаи почтаро тафтиш кунед'
	},
	Results: {
		'Select flight': 'Самти парвозро интихоб кунед',
		'Select flight to on': 'Самти парвозро ба {{city}} дар {{date}} интихоб кунед',
		'Monthly price': 'Ба моҳ',
		'Weekly price': 'Ба ҳафта',
		Back: 'Ба қафо',
		Sorting: 'Банавъҷудокунӣ',
		Filters: 'Филтрҳо',
		'Sort by': 'Банавъҷудокунӣ',
		Arrival: 'Вақти омадан',
		Departure: 'Парвоз',
		'Best flight': 'Парвози беҳтарин',
		Price: 'Нарх',
		'Flight time': 'Вақт дар роҳ',
		Returning: 'Бозгашт',
		Departing: 'Ба он ҷо',
		'You\'ve chosen': 'Парвозҳои интихобшуда',
		'Depart on': 'Парвоз',
		'Departure time': 'Вақти парвоз',
		'save up to': 'сарфа кунед',
		'Sold out': 'Фурӯши чиптаҳо ба анҷом расид',
		'Show flights': 'Нишон додани вариантҳо',
		'Unfortunately, all seats on selected flight are already sold out.':
			'Мутаассифона, ҳамаи чиптаҳо ба самти интихобкардаи шумо аллакай фурӯхта шуданд.',
		'We can offer you another flights for the same dates.':
			'Самтҳои парвозро ба худи ҳамон сана пешниҳод карда метавонем.',
		'Other dates': 'Санаҳои дигар',
		'Total price': 'Ҳамагӣ',
		'Want to continue booking on your computer?': 'Бандкуниро дар компютери худ давом додан мехоҳед?',
		'Continue booking': 'Давом додани бандкунӣ',
		'Only direct flights': 'Танҳо самтҳои парвози бевосита',
		'Only business class': 'Танҳо бизнес класс',
		Ok: 'Ок',
		'Show price diagram': 'Нақшаи нархҳо',
		'Redeem miles': 'Истифода бурдани миляҳо',
		Card: 'Корт',
		'Change card': 'Иваз кардани корт',
		'Pay by money': 'Бо пул пардохт кардан',
		'You sure?': 'Боварӣ доред?',
		'Delete card from your account?': 'Корт аз аккаунти шумо нест карда шавад?',
		No: 'Не',
		Yes: 'Ҳа',
		Nonstop: 'Гузаришҳо',
		'Business Class': 'Бизнес класс',
		Attention: 'Диққат диҳед',
		'You are buying a separate ticket for a child. For children under 12 years old unaccompanied traveling is not allowed. On the passenger data page select who will fly with the child: enter the ticket number and the name of the accompanying person over 18 years old. Please note: both passengers must be of the same class of service.':
			'Шумо барои кӯдак чиптаи алоҳида мехаред. Кӯдакони то 12 сола бе ҳамроҳии болиғон саёҳат карда наметавонанд. Дар саҳифаи воридкунии маълумотҳои мусофир нишон диҳед, ки бо кӯдак кӣ парвоз мекунад: рақами чиптаи ҳавопаймо ва ному насаби ҳамроҳикунандаи аз синни 18 сола калонро ворид кунед. Диққат диҳед: дараҷаи хизматрасонии ҳар ду мусофирон бояд якхела бошад.',
		'If you still have questions, please contact the Contact Center.':
			'Агар саволҳо дошта бошед, ба Маркази тамос муроҷиат кунед.'
	},
	RetrieveBooking: {
		'Booking ID': 'Рақами чипта, фармоиш ё ки коди бандкунӣ',
		'Security code': 'Коди дастрасӣ ё ки насаби мусофир',
		'Retrieve booking': 'Дастрасӣ ба бандкунӣ',
		Open: 'Ҷустуҷӯъ',
		'Enter ticket number': 'Рақами чиптаро ворид кунед',
		'Enter passenger last name': 'Насаби мусофирро ворид кунед',
		'Enter your book code or ticket number': 'Коди бандкунӣ ё ки насаби чиптаро ворид кунед',
		'Incorrect value': 'Насаби носаҳеҳ',
		'Ticket number': 'Рақами чипта',
		'Required field': 'Сатри ҳатмӣ',
		'Please enter ticket number for passenger you would like to check-in':
			'Лутфан, рақами чиптаи мусофирро, ки ба самти парвоз аз қайд гузаронидан мехоҳед, ворид кунед',
		'Order not found': 'Фармоиш ёфт нашуд',
		'Passenger not found': 'Мусофир ёфт нашуд',
		'You can find security code in your booking confirmation email':
			'Коди дастрасиро дар мактуби электронӣ дар бораи тасдиқкунии бандкунӣ ёфтан мумкин аст',
		'The order is being paid at the moment, please try again later':
			'Дар айни замон пардохти фармоиш гузаронида мешавад, кӯшишро такрор кунед',
		'Enter your ticket number': 'Рақами чиптаро ворид кунед',
		'Booking not found. Please, check the information entered or use your e-ticket number for identification':
			'Бандкунӣ ёфт нашуд. Лутфан, иттилооти воридкардашударо пур кунед ё ки аз рақами чиптаи электронӣ барои идентификатсия истифода баред',
		'Online check-in is not available. Check-in only at the airport':
			'Бақайдгирии онлайнӣ дастнорас аст. Бақайдгирӣ танҳо дар фурудгоҳ'
	},
	Schedule: {
		'Where are you flying from': 'Аз куҷо парвоз мекунед',
		'Where are you flying to': 'Ба куҷо парвоз мекунед аз',
		'Is operated by': 'Самти парвозро иҷро мекунад',
		'We did not find flights to the selected cities': 'Мо самтҳои парвозро ба шаҳрҳои интихобшуда наёфтем',
		'Please select another city or change your search. If you would like to purchase a ticket for a specific city, please contact customer service.':
			'Лутфан, шаҳри дигарро интихоб кунед ё ки ҷустуҷӯи худро тағйир диҳед. Агар чиптаро ба шаҳри муайян харидан хоҳед, бо хадамоти дастгирии мизоҷон тамос гиред.'
	},
	ScheduleForm: {
		Schedule: 'Ҷадвал',
		From: 'Аз куҷо',
		To: 'Ба куҷо',
		'From, enter city or country': 'Аз куҷо, шаҳр ё ки кишварро ворид кунед',
		'To, enter city or country': 'Ба куҷо, шаҳр ё ки кишварро ворид кунед',
		'Please select {{type}} airport': 'Фурудгоҳи {{type}} интихоб кунед',
		'Please select different airports': 'Фурудгоҳҳои гуногунро интихоб кунед',
		arrival: 'омаданро',
		departure: 'парвозро'
	},
	SearchForm: {
		'Enter promo code': 'Ворид кардани промокод',
		'Redeem miles': 'Сарф кардани миляҳо',
		'Set simple route': 'Ба хатсайри оддӣ',
		'Set multi city route': 'Тартиб додани хатсайри мураккаб',
		From: 'Аз куҷо',
		To: 'Ба куҷо',
		'Please select {{type}} airport': 'Фурудгоҳи {{type}} интихоб кунед',
		'Please select different airports': 'Фурудгоҳҳои гуногунро интихоб кунед',
		Search: 'Ҷустуҷӯъ',
		'Please select departure date': 'Санаи парвозро интихоб кунед',
		Outbound: 'Ба он ҷо',
		Return: 'Бозгашт',
		Dates: 'Санаи парвоз',
		arrival: 'омаданро',
		departure: 'парвозро',
		'From, enter city or country': 'Шаҳр ё ки кишвар',
		'To, enter city or country': 'Шаҳр ё ки кишвар',
		passenger_0: 'мусофир',
		passenger_1: 'мусофирон',
		passenger_2: 'мусофирон',
		Passengers: 'Мусофирон',
		'Other categories': 'Тоифаҳои дигар',
		Clear: 'Тоза кардан',
		Done: 'Омода',
		'Enter name or code of category': 'Номгӯй ё ки коди тоифаро ворид кунед',
		'Pay by miles': 'Миляҳоро истифода бурдан мехоҳам',
		'Please select passengers': 'Мусофиронро интихоб кунед',
		'Offer hotels': 'Пешниҳод кардани меҳмонхонаҳо',
		'Departure airport or city': 'Шаҳри парвоз',
		'Arrival airport or city': 'Шаҳри омадан'
	},
	SearchFormDatepicker: {
		Oops: 'Упс',
		'Something went wrong, please check your internet connection or come back later':
			'Чизе нодуруст шут, пайвастшавӣ бо интернетро тафтиш намоед ё ки дертар кӯшиш кунед',
		Ok: 'Ок',
		'Without back date': 'Чиптаи бозгашт лозим нест',
		Clear: 'Аз нав',
		Done: 'Омода',
		'One way': 'Омода',
		'Price matrix': 'Муқоисаи нархҳо',
		Calendar: 'Тақвим',
		'Price graph': 'Нархҳо ба моҳ',
		Outbound: 'Ба он ҷо',
		Return: 'Бозгашт',
		'Approximate prices for 1 person for 1 direction': 'Нархҳои тахминӣ ба 1 нафар ба 1 тараф нишон дода шудаанд'
	},
	SeatMap: {
		'Less than 24 hours left before the flight': 'То парвози самти парвоз камтар аз 24 соат монд',
		'You can select seats using the online registration service after issuing tickets':
			'Шумо ба интихоби ҷой бо истифода аз хизматрасонии бақайдгирии онлайнӣ баъд аз ба расмият даровардани чиптаҳо гузашта метавонед',
		Restriction_ElderlyPerson: 'Мусофирони синнашон аз 65 сола боло',
		Restriction_Unaccompanied: 'Кӯдакони ҳамроҳинашаванда',
		Restriction_SeriouslyIllPeople: 'Шахсон бо имконияти маҳдуд',
		Restriction_DoNotSpeakTheLanguage: 'Мусофирони дар забони даста гап намезада',
		Restriction_EscortedChildren: 'Кӯдакони ҳамроҳинашаванда',
		Restriction_Infant: 'Мусофирон бо навзодон',
		Restriction_NeedOxygenEquipment: 'Мусофирони ба таҷҳизоти махсуси оксигенӣ ниёздошта',
		Restriction_PassengersOnStretchers: 'Мусофирони камҳаракат ва одамон бо имконияти маҳдуд',
		Restriction_PassengersUnder18: 'Шахсони хурдтар аз 18 сола',
		Restriction_PregnantWomen: 'Занони ҳомиладор',
		Restriction_RequiringAccompany: 'Мусофирони ба ҳамроҳикунӣ ниёздошта',
		Restriction_VisuallyOrHearingImpaired: 'Мусофирон бо вайроншавии босира ё ки шунавоӣ',
		Restriction_WithAnimals: 'Мусофирон бо ҳайвонот дар салон',
		'This seat is forbidden for': 'Ин ҷой барои интихоб манъ аст барои',
		select: 'итихоб кардан',
		'not available': 'дастнорас',
		'Unfortunately, seat selection on this flight is not available.':
			'Мутаассифона, интихоби ҷой ба ин самти парвоз дастнорас аст.',
		'Next flight': 'Парвози навбатӣ',
		'Reserved seat': 'Ҷойи ишғолшуда',
		'90% on the left side': 'офтоб дар чап мешавад',
		'90% on the right side': 'офтоб дар рост мешавад',
		'Business class': 'Бизнесс класс',
		'Economy class': 'Эконом класс',
		'First class': 'Якум класс',
		Business: 'Бизнес-класс',
		Economy: 'Эконом-класс',
		First: 'Якум-класс',
		Exit: 'Баромад',
		seat_0: '{{count}} ҷой',
		seat_1: '{{count}} ҷойҳо',
		seat_2: '{{count}} ҷойҳо',
		Seats: 'Ҷойҳо',
		Adult: 'Калонсол',
		Child: 'Кӯдак',
		Infant: 'Навзод',
		'Infant with seat': 'Навзод бо ҷой',
		Free: 'Ройгон',
		'MAIN DECK': 'ПАЛУБАИ АСОСӢ',
		'You can choose your preferred seats.': 'Ҷойҳои қулайтаринро интихоб кунед',
		'UPPER DECK': 'ПАЛУБАИ БОЛОӢ',
		'Seat details': 'Иттилоот дар бораи ҷойҳо',
		Select: 'Итихоб кардан',
		'Select seat': 'Интихоб кардани ҷой',
		'Select your seats': 'Ҷойро интихоб кунед',
		'Select passenger': 'Мусофирро интихоб кунед',
		Cancel: 'Бекор кардан',
		'Take this seat': 'Интихоб кардани ҷой',
		'Change seat': 'Иваз кардани ҷой',
		Recommend: 'Тавсия медиҳем',
		'Fly together!': 'Ҳамҷоя парвоз кунед!',
		'Show recommended seats': 'Ҷойҳои тавсиядодашаванда',
		From: 'Аз',
		Total: 'Ҳамагӣ',
		'Choose your seat': 'Ҷойҳоро интихоб кунед',
		'Choose myself': 'Худ интихоб кардан',
		Confirm: 'Тасдиқ кардан',
		'Recommended seats': 'Тавсия медиҳем',
		Comfort: 'Ҷойи ҳаловатбахш',
		Preferred: 'Ҷойи афзалтар',
		Standart: 'Ҷойи стандартӣ',
		Clear: 'Тоза кардан',
		'Clear all': 'Ҳамаашро тоза кардан',
		'Passenger, {{type}}': 'Мусофир, {{type}}',
		'Next Flight': 'Парвози навбатӣ',
		Back: 'Ба қафо',
		from: 'аз',
		Done: 'Омода',
		'The top ones get the top seats. Be on top!': 'Ҷойҳои беҳтарин ба аввалинҳо насиб мекунад. Якум бимонед!',
		'If you don\'t select a seat, we\'ll automatically allocate your seats when you check-in.':
			'Ҳозир интихоб кардани ҷойро тавсия медиҳем, ҷойҳои беҳтарин ба аввалинҳо насиб мекунанд!',
		'Pay attention!': 'Диққат диҳед!',
		'The airline reserves the right to replace the aircraft.':
			'Ширкати ҳавопаймоӣ ҳуқуқи иваз кардани ҳавопайморо дорад.',
		'In the event of an aircraft replacement, passengers who have paid for the “seat selection” service will be provided with seats on the plane that are similar in price and comfort, while maintaining the following parameters':
			'Дар ҳолати иваз гардидани ҳавопаймо, ба мусофироне, ки хизматрасонии «Интихоби ҷой»-ро пардохт кардаанд, ҷойҳои аз рӯи нарх ва ҳаловатнокӣ монанд бо нигоҳ доштани параметрҳои зерин пешкаш карда мешаванд',
		'- Cost of services;': '— Арзиши хизматрасонӣ;',
		'- Location of the place relative to the window / aisle;': '— Ҷойгиршавии ҷой нисбати тиреза/гузаргоҳ',
		'- Joint seating, if one was originally selected;':
			'— Ҷойгиркунии ҳамҷоя, агар он аз аввал интихоб шуда бошад;',
		'- Placement in the front row of the cabin, if one was originally selected.':
			'— Ҷойгиркунӣ дар қатори якуми салон, агар он аз аввал интихоб карда шуда бошад.',
		'Terms & conditions': 'Муфассалтар дар бораи хизматрасонӣ',
		Continue: 'Давом додан',
		Note: 'Муҳим',
		SeatMap_Comfort: 'Ҳаловатбахш',
		SeatMap_Preferred: 'Писандидатар',
		SeatMap_Standart: 'Стандартӣ',
		SeatMap_Standard: 'Стандартӣ',
		'Selected seat is not available': 'Ҷойи интихобшуда дастнорас аст',
		'The passenger can select a suitable seat marked for passengers with pets on the map. The airline has the right to transfer a passenger with an animal.':
			'Мусофир курсии мутобиқ бо қайд барои мусофирон бо ҳайвонотро дар харита интихоб карда метавонад. Ширкати ҳавопаймоӣ ҳуқуқи ба ҷойи дигар шинонидани мусофир бо ҳайвонро дорад.',
		'This seat is allowed for': 'Ин ҷой иҷозат дода шудааст барои интихоб барои',
		Permissions_WithAnimals: 'Мусофирон бо ҳайвонот',
		'Free seat': 'Ройгон',
		'Free seats': 'Ҷойҳои ройгон',
		'Information for the place': 'Иттилоот барои ҷой',
		'Chair back does not recline': 'Пушти курсӣ хам намешавад',
		'Double seat': 'Ҷойи дучанд',
		'An extra seat can also be booked for the safe transport of valuable and fragile items such as antiques, artifacts, family heirlooms or oversized musical instruments.':
			'Инчунин ҷойи иловагиро барои кашонидани бехатари ашёҳои гаронбаҳо ва зудшикани ба монанди антиквариат, артефактҳо, ашёҳои пурарзиши оилавӣ ё ки асбобҳои калонҳаҷми мусиқиро банд кардан мумкин аст.',
		'When choosing the «Double Seat» service, the seats previously added by the passenger will be deleted':
			'Ҳангоми интихобкунии хизматрасонии «Ҷойи дучанд» ҷойҳои қаблан аз ҷониби мусофир иловакардашуда нест карда мешаванд',
		'When you select this service, it will be automatically applied to all flights of your route':
			'Ҳангоми интихоби ин хизматрасонӣ он ба таври худкор барои ҳамаи парвозҳои хатсайри шумо татбиқ мегардад',
		'When the «Double Seat» service is disabled, the seats added by the passenger earlier will be deleted':
			'Ҳангоми хомӯшкунии хизматрасонии «Ҷойи дучанд» ҷойҳои қаблан аз ҷониби мусофир иловакардашуда нест карда мешаванд',
		'Seat selection': 'Интихоби ҷой',
		'Children under 2 years of age fly in the same seat with an adult':
			'Кӯдакони то 2 сола дар як курсӣ бо ҳамроҳии калонсол парвоз мекунанд',
		'Window seat': 'Ҷой дар назди тиреза',
		'Seat with no window': 'Ҷой бе тиреза',
		'The service applies to all flights': 'Хизматрасонӣ барои ҳамаи парвозҳо татбиқ мегардад',
		'Selected seats will be deleted': 'Ҷойҳои интихобшуда нест карда мешаванд',
		'Seat next to the partition': 'Ҷой дар паҳлӯи иҳота',
		'Comfort seat': 'Ҷойи ҳаловатбахш'
	},
	SecureAccess: {
		'Enter your access confirmation number. For security reasons, it was sent to the email you provided when creating the order.':
			'Рақами тасдиқкунии дастрасӣ ба фармоишро ворид кунед. Бо мақсади амният он ба почтае, ки ҳангоми офаридани фармоиш нишон дода будед, равона карда шуд.',
		'Ticket / order number from e-mail': 'Рақами чипта ё ки фармоиш аз мактуб',
		'Add booking': 'Илова кардани бандкунӣ',
		Continue: 'Давом додан',
		'The entered code does not match the code from the email': 'Коди воридкардашуда ба код аз мактуб мутобиқ нест'
	},
	Segment: {
		Departure: 'Парвоз',
		Flight: 'Рақами самти парвоз',
		Terminal: 'Терминал',
		Gate: 'Баромадан ба саворкунӣ',
		Boarding: 'Саворкунӣ',
		'Fare rules': 'Қоидаҳои тарофа',
		'Airport check-in': 'Бақайдгирӣ дар фурудгоҳ',
		'Baggage info': 'Иттилоот дар бораи бағоҷ',
		Economy: 'Эконом',
		Business: 'Бизнес',
		'Cancel check-in': 'Бекор кардани бақайдгирӣ'
	},
	SelectSegment: {
		Confirm: 'Тасдиқ кардан',
		'Check-in for flights': 'Қайд ба самтҳои парвоз',
		Flight: 'Самти парвоз',
		Select: 'Итихоб кардан',
		GetTalon: 'Бақайдгирӣ гузашта шуд. Гирифтани талони саворшавӣ',
		GoToCheckin: 'Бақайдгирӣ кушода аст. Гузариш ба бақайдгирӣ'
	},
	SelectedPassenger: {
		Birthday: 'Санаи таваллуд',
		Gender: 'Ҷинс',
		Male: 'Мардона',
		Female: 'Занона',
		Citizenship: 'Шаҳрвандӣ',
		Passport: 'Шиноснома',
		MilitaryIDCard: 'Билети ҳарбӣ',
		DocOfPassportLusing: 'Шаҳодатномаи муваққати шахсият',
		DiplomaticPassport: 'Шиносномаи дипломатӣ',
		InternationalPassportNotRU: 'Шиносномаи хориҷӣ',
		InternationalPassportRU: 'Шиносномаи хориҷӣ',
		InternationalPassport: 'Шиносномаи хориҷӣ',
		NationalPassport: 'Шиносномаи миллӣ',
		SeamanDocument: 'Шинономаи баҳрнавард',
		SeniorDocument: 'Шаҳодатномаи нафақа',
		BirthRegDocument: 'Шаҳодатнома дар бораи таваллуд',
		CertificateOfConvictedVacation: 'Шаҳодатномаи шахсият',
		ResidencePermit: 'Иҷозатномаи иқомат',
		Ticket: 'Рақами чипта',
		'Add frequent flyer number for': 'Ворид кардани рақами корти садоқат барои ',
		Add: 'Илова кардан',
		'Frequent Flyer Number': 'Рақами корти садоқат',
		'Add frequent flyer': 'Илова кардани корти садоқат',
		'Frequent flyer': 'Корти садоқат',
		'Expiry date': 'Муҳлати эътибор',
		'Cancel check-in': 'Бекор кардани бақайдгирӣ'
	},
	Service: {
		from: 'аз',
		Total: 'Ҳамагӣ',
		Close: 'Пӯшидан',
		free: 'Ройгон',
		Done: 'Омода',
		Clear: 'Тоза кардан'
	},
	ServiceRecommendation: {
		'To save your time, we have selected for you the best available seats on the plane.':
			'Барои сарфа кардани вақти шумо, мо ҷойҳои қулайтарини озод дар ҳавопайморо интихоб кардем.',
		'Seats recommendation': 'Ҷойҳои тавсиядодашаванда',
		Change: 'Худ интихоб кардан',
		Confirm: 'Тасдиқ кардан',
		Total: 'Ҳамагӣ',
		Flight: 'Самти парвоз',
		Seats: 'Ҷойҳо',
		Price: 'Нарх',
		FREE: 'Ройгон',
		Details: 'Тафсилот',
		Allergens: 'Аллергенҳо',
		'OK, thank you': 'Фаҳмо, ташаккур',
		'We offer you this meal': 'Таъоми пешниҳодавашанда пешкаш карда мешавад',
		'for FREE': 'РОЙГОН',
		'on all flight directions': 'дар ҳамаи самтҳои парвоз',
		'on flight directions': 'дар самтҳои',
		'for all passengers': 'барои ҳамаи мусофирон',
		'for passengers': 'барои мусофирон'
	},
	ServiceWithSegments: {
		'Next flight': 'Хатсайри навбатӣ'
	},
	SocialAuth: {
		'Social networks accounts': 'Аккаунтҳо дар шабакаҳои иҷтимоӣ',
		'Quick login to your account': 'Даромади зуд ба аккаунти худ',
		'Connect another social media account': 'Аккаунт дар шабакаи иҷтимоии дигарро пайваст кунед'
	},
	Stepbar: {
		Flights: 'Парвозҳо',
		Seats: 'Ҷойҳо',
		Baggage: 'Бағоҷ',
		Insurance: 'Суғуртакунӣ',
		Meal: 'Ғизо',
		Passengers: 'Мусофирон',
		Extras: 'Хизматрасониҳо',
		Payment: 'Пардохт',
		Order: 'Фармоиш',
		'You can {{payload}}': 'Шумо метавонед {{payload}}',
		'add services': 'хизматро ба фармоиш илова кунед',
		'change dates': 'санаи парвозро тағйир диҳед'
	},
	Subscriptions: {
		'You have a subscription': 'Обуна доред',
		'There are users in the order who are not covered by your subscription. The price of their tickets is considered without discount.':
			'Дар фармоиш истифодадабарандагоне ҳастанд, ки ба обуна ворид нестанд. Арзиш барои чунин мусофирон бе таҳфиф ҳисоб карда мешавад',
		'Members without Subscription': 'Мусофирон бе обуна',
		Passenger: 'Мусофир',
		Without: 'Бе обуна',
		With: 'Бо обуна',
		'Continue, I agree with this price': 'Давом додан, бо нарх розиям',
		'Add passengers to subscription': 'Илова кардани мусофирон ба обуна',
		'Reselect services and seats': 'Такроран интихоб кардани хизматрасонӣ ва ҷойҳо',
		'Do you have regular flights?': 'Зуд-зуд парвоз мекунед?',
		'Cut costs with a subscription': 'Обуна хароҷотҳоро кам мекунад',
		'View Offers': 'Дидани пешниҳодҳо',
		'Seat selection and other subscription services at a reasonable price':
			'Интихоби ҷой ва хизматҳои дигар бо обуна бо нархи дастрас',
		'View options': 'Дидани вариантҳо',
		'Subscription member': 'Ба обуна дохил аст',
		'Discounts apply to the user': 'Таҳфифҳо барои ин истифодабаранда эътибор доранд',
		formatDate: 'рр.ММ.сссс',
		Subscribe: 'Обуна шудан',
		'WebSky \nSubscription': 'Обунаи WebSky',
		'Your account details': 'Маълумотҳои аккаунти шумо',
		Plan: 'Нақша',
		'Date of end': 'Санаи анҷом',
		'Your members': 'Иштирокчиёни шумо',
		from: 'аз',
		Member: 'Иштирокчӣ',
		You: 'Шумо',
		Remove: 'Нест кардан',
		'Add member': 'Илова кардани иштирокчӣ',
		'You can add more': 'Шумо боз {{count}} {{member}} илова карда метавонед',
		'Added max number of members': 'Шумораи максималии иштирокчиён илова карда шудааст',
		member_0: 'иштирокчиро',
		member_1: 'ишттирокчиёнро',
		'Still have questions?': 'Саволҳо монданд?',
		Payments: 'Пардохтҳо',
		'The next payment for your subscription will be {{date}}':
			'Пардохти навбатӣ барои обуна {{date}} интизорӣ меравад',
		'Cancel auto-renewal': 'Бекор кардани дарозкунии худкор',
		'A unique subscription gives guaranteed discounts not only on your ticket, but also on tickets for your loved ones':
			'Обунаи эксклюзивӣ таҳфифҳои кафолатнокро на танҳо ба чиптаи шумо, вале ба чиптаҳои наздикони шумо низ медиҳад',
		'The subscriber can use the privileges both separately and together with his fellow travelers, whilefellow travelers - only together with the subscriber (personal data of passengers are indicated whensubscribing and are not subject to change).':
			'Обуначӣ аз бартариятҳо ҳам дар алоҳидагӣ, ҳам ҳамҷоя бо ҳамсафарони худ, ҳамсафарон бошанд, танҳо бо муштарӣ истифода бурда метавонад (маълумотҳои фардии мусофирон ҳангоми обуна нишон дода ва тағйир дода намешаванд).',
		'Read more': 'Бештар донистан',
		'Get a subscription': 'Гирифтани обуна',
		'Your data': 'Маълумотҳои шумо',
		firstName: 'Ном',
		lastName: 'Насаб',
		birthDate: 'Санаи таваллуд',
		latinFirstName: 'Ном (бо ҳуруфи лотинӣ)',
		latinLastName: 'Насаб (бо ҳуруфи лотинӣ)',
		Required: 'Сатри ҳатмӣ',
		'Enter date in dd.mm.yyyy format': 'Санаро дар шакли рр.мм.сссс ворид кунед',
		'For worlds flights': 'Барои парвозҳои байналхалқӣ',
		'Add new Travel companion': 'Илова кардани ҳамсафари нав',
		'Add Member': 'Илова кардани {{member}}',
		Cancel: 'Бекор кардан',
		'Select from Travel companions': 'Аз ҳамсафарон илова кунед',
		'Add new': 'Навро илова кардан',
		'Please, select at least one member': 'Лутфан, ақаллан як ҳамсафарро илова кунед',
		'Choose your plan now': 'Интихоб кардани тарофа',
		'You get more cost-efficient flights + greater comfort': 'Хизматрасониҳои муфид ва ҳаловати зиёд мегиред',
		'Select your plan now': 'Тарофаи худро интихоб кунед',
		Popular: 'Машҳур',
		year: 'сол',
		Select: 'Итихоб кардан'
	},
	Timer: {
		'Didn\'t get the code?': 'Кодро нагирифтед?',
		'Resend it': 'Боз як маротиба фиристодан',
		'Code sent': 'Код фиристода шуд',
		'You can get new code in': 'Кодро дархост карда метавонед баъд аз',
		'Sending message': 'Кодро мефиристем'
	},
	Title: {
		companyName: 'Websky',
		'Find tickets': 'Ҷустуҷӯи чиптаҳои ҳавопаймоӣ',
		'Checkout order': 'Ба расмият даровардани фармоиш',
		Payment: 'Пардохти фармоиш',
		Account: 'Утоқи шахсӣ'
	},
	Toolbar: {
		Total: 'Ба пардохт',
		Continue: 'Давом додан',
		Back: 'Ба қафо',
		'Oops...': 'Упс...',
		'An unexpected error has occurred during the creating order process. Please try again later or contact a customer support service.':
			'Ҳангоми офаридани фармоиш хатогӣ рух дод. Такроран кӯшиш кунед ё ки бо хадамоти дастгирии мизоҷон тамос гиред.',
		'OK, thank you': 'Фаҳмо, ташаккур',
		'miles will be awared': 'миля барои ин парвоз',
		'miles will be charged': 'миля соқит карда мешавад',
		'This flight will be partially paid by miles': 'Ин парвоз қисман бо миляҳо пардохт карда мешавад',
		'Fly with us and get miles': 'Бо мо парвоз кунед ва миляҳо гиред'
	},
	Traveller: {
		firstName: 'Ном',
		lastName: 'Насаб',
		middleName: 'Номи падар',
		birthDate: 'Санаи таваллуд',
		email: 'Суроғаи почтаи эл.',
		phone: 'Рақами телефон',
		nationality: 'Шаҳрвандӣ',
		Add: 'Илова кардан',
		Required: 'Сатри ҳатмӣ',
		'Please enter a valid email': 'Суроғаи саҳеҳи почтаи электрониро ворид кунед',
		'Please enter a valid phone': 'Рақами саҳеҳи телефонро ворид кунед',
		'Please enter a valid date': 'Санаи саҳеҳро ворид кунед',
		'FLIGHT PREFERENCES': 'АФЗАЛИЯТҲО',
		Seats: 'Ҷой',
		Meal: 'Ғизо',
		Save: 'Маҳфуз кардан',
		'Remove passengers data': 'Аз рӯихат нест кардан',
		Cancel: 'Бекор кардан',
		'Add companion': 'Илова кардани ҳамсафар',
		'Add document': 'Илова кардани ҳуҷҷат',
		'Frequent Flyer': 'Илова кардани корти садоқат',
		'Personal details': 'Профил',
		'An error occurred while executing the request, please try again':
			'Ҳангоми иҷрокунии дархост хатогӣ рух дод, боз такрор кунед',
		Contacts: 'Тамосҳо',
		'With the help of this data, we will be able to inform the fellow traveler about changes in booking, flight status, check-in time, etc. Optional data.':
			'Бо ёрии ин маълумотҳо, мо ба мусофир дар бораи тағйирот дар фармоиш, оғози бақайдгирӣ ва ғайра хабар хоҳем дод.',
		Documents: 'Ҳуҷҷатҳо',
		'Save the details of your internal or foreign passport, this will speed up the process of purchasing tickets.':
			'Барои тезонидани ҷараёни хариди чиптаҳо, маълумотҳо дар бораи шиносномаҳоро маҳфуз кунед'
	},
	VipServiceSelect: {
		'Different for other flight?': 'Барои ҳар як парвоз алоҳида танзим кардан',
		Cancel: 'Бекор кардан',
		Confirm: 'Тасдиқ кардан',
		Total: 'Ҳамагӣ',
		from: 'аз'
	},
	VisaForm: {
		applicableCountry: 'Давлати қабулкунанда',
		birthPlace: 'Санаи таваллуд',
		issueDate: 'Санаи дода шудани раводид',
		issuePlace: 'Ҷойи дода шудани раводид',
		number: 'Рақами раводид',
		Required: 'Сатри ҳатмӣ',
		'format error, only latin and digits': 'Танҳо ҳарфҳои лотинӣ ва ҳарфҳо',
		'only latin and digits': 'Танҳо ҳарфҳои лотинӣ ва ҳарфҳо',
		'Enter date in dd.mm.yyyy format': 'Санаи саҳеҳро ворид кунед',
		'Incorrect date': 'Санаи носаҳеҳ',
		'Latin characters only': 'Танҳо ҳарфҳои лотинӣ'
	},
	Voucher: {
		'E-voucher': 'Промокод',
		Add: 'Илова кардан',
		Done: 'Омода',
		Details: 'Муфассалтар',
		'Enter code': 'Промокодро ворид кунед'
	},
	Warnings: {
		Clarification: 'Диққат диҳед'
	},
	translation: {
		d: 'р',
		h: 'с',
		m: 'м',
		s: 'с',
		kg: 'кг',
		'It looks like something went wrong': 'Аз афташ чизе нодуруст шуд',
		'Please reload the page or start a new search': 'Лутфан, саҳифаро нав кунед ё ки ҷустуҷӯи навро оғоз диҳед.',
		'Reload the page': 'Саҳифаро нав кунед',
		Refresh: 'Нав кардан',
		'We couldn\'t find any flights for given dates': 'Мо ба санаҳои интихобшуда самтҳои хатсайрро наёфтем',
		'Unfortunately, there are no available flights for given dates or all tickets have been already sold out. Please select another date or modify your search parameters.':
			'Мутаассифона, ба санаҳои интихобкардаи шумо самтҳои дастрас нестанд ё ки ҳамаи чиптаҳо фурӯхта шуданд. Барои оғоз кардани ҷустуҷӯ ба санаи дигар кӯшиш кунед ё ки самти ҷустуҷӯро тағйир диҳед.',
		'Please select another date or modify your search. If you wish to purchase a ticket for this particular date, please contact customer support.':
			'Лутфан, санаи дигарро интихоб кунед ё ки ҷустуҷӯи худро тағйир диҳед. Агар чиптаро ба санаи муайян харидан хоҳед, бо хадамоти дастгирии мизоҷон тамос гиред.',
		'It looks like search results are obsolete': 'Аз афташ, ин натиҷаҳои ҷустуҷӯ кӯҳна шуданд',
		'Please start a new search using the form above':
			'Лутфан, ҷустуҷӯи навро бо истифода аз шакли болоӣ оғоз диҳед',
		'The specified cost is for all passengers and includes taxes and fees':
			'Арзиш барои ҳамаи мусофирон, аз он ҷумла, андозҳо ва боҷҳо нишон дода шудааст.',
		'Local time': 'Бо вақти маҳаллӣ',
		'Go to main page': 'Ба асосӣ гузаштан'
	}
};
